export const translations = {
  it: {
    common: {
      loading: 'Loading...',
      yes: 'Sì',
      no: 'No',
      hidden: 'Nascosti',
      notesPlaceholder: 'Note per produzione, installazione o richieste cliente',
    },
    home: {
      welcome: 'Benvenuto nel Configuratore',
      heroSubtitle: 'Scegli un configuratore per iniziare.',
      quickSearchPlaceholder: 'Cerca un configuratore...',
      openConfigurator: 'Apri configuratore',
      noResults: 'Nessun configuratore trovato con questa ricerca.',
      customProfiles: 'PROFILI LED SU MISURA',
      cardCustomDescription: 'Taglio su misura e accessori compatibili.',
      cardCustomEta: '3-6 min',
      emptyProfiles: 'PROFILI ALLUMINIO VUOTI',
      cardLooseDescription: 'Profili alluminio pronti per personalizzazione.',
      cardLooseEta: '2-4 min',
      stripLed: 'STRIP LED',
      cardStripDescription: 'Scelta rapida per potenza, IP e colore LED.',
      cardStripEta: '2-5 min',
      powerSupplies: 'ALIMENTATORI LED',
      cardPowerDescription: 'Driver e alimentatori abbinabili ai sistemi LED.',
      cardPowerEta: '1-3 min',
      catalog: 'CATALOGO',
      cardCatalogDescription: "Esplora rapidamente l'intera gamma prodotti.",
      cardCatalogEta: '2-4 min',
      btmSystem: 'BTM SYSTEM',
      cardBtmDescription: 'Configurazione guidata binari elettrificati 24V/230Vac',
      cardBtmEta: '3-7 min',
      newArrivalsTitle: 'Novita',
      newArrivalsSubtitle: 'Scopri gli ultimi prodotti inseriti.',
      cardNewArrivalsEta: '1-2 min',
      onSaleTitle: 'Prodotti in Offerta',
      onSaleSubtitle: 'Scopri le offerte attive',
      cardOnSaleEta: '1-2 min',
      categoryConfigurator: 'Configuratore',
      categoryProfiles: 'Profili',
      categoryLighting: 'Illuminazione',
      categoryElectronics: 'Elettronica',
      categoryCatalog: 'Catalogo',
      categorySystems: 'Sistemi',
      categoryNews: 'Novita',
      categoryPromo: 'Promo',
      greetMorning: 'Buongiorno',
      greetAfternoon: 'Buon pomeriggio',
      greetEvening: 'Buonasera',
      todayQuestion: 'Cosa configuriamo oggi?',
      newQuote: 'Nuovo preventivo',
      newOrder: 'Nuovo ordine',
      resumeCart: 'Riprendi il carrello',
      openCart: 'Apri carrello',
      cartEmpty: 'Il carrello è vuoto: parti da un configuratore qui sotto.',
      editingOrder: 'In modifica: ordine',
      draftQuote: 'Nuovo preventivo in corso',
      draftOrder: 'Nuovo ordine in corso',
      linesCount: '{{count}} righe',
      zonesCount: '{{count}} zone',
      lastOrders: 'Ultimi ordini',
      seeAll: 'Vedi tutti',
      noOrders: 'Nessun ordine ancora.',
      statusPrepared: 'Preparato',
      statusRejected: 'Rifiutato',
      statusSent: 'Inviato',
      statusReceived: 'Ricevuto',
      sectionTitle: 'Configura e ordina',
      sectionHint: 'Scegli da dove partire',
      open: 'Apri',
    },
    account: {
      title: 'Account',
      profile: 'Profilo',
      addressBook: 'Rubrica',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefono',
      role: 'Ruolo',
      discount: 'Sconto',
      company: 'Azienda',
      quotes: 'Preventivi',
      enabled: 'Abilitati',
      disabled: 'No',
      companyKey: 'Chiave azienda',
      showPrices: 'Mostra prezzi',
      shareOrders: 'Condividi ordini con la mia azienda',
      sharingUpdateError: 'Impossibile aggiornare la preferenza di condivisione ordini.',
      country: 'Paese',
      saveCountry: 'Salva paese',
      countryUpdateError: 'Impossibile aggiornare il paese.',
      countryIt: 'Italia',
      countryAt: 'Austria',
      countryDe: 'Germania',
      countryEs: 'Spagna',
      countryFr: 'Francia',
      countryOther: 'Altro',
      contactReferent: 'Per assistenza contatta il referente:',
    },
    header: {
      admin: 'Admin',
      openMenu: 'Apri menu',
      closeMenu: 'Chiudi menu',
      openSearch: 'Apri ricerca',
      closeSearch: 'Chiudi ricerca',
      searchPlaceholder: 'Cerca prodotti o ordini...',
      searchField: 'Campo di ricerca',
      logout: 'Logout',
      logoutConfirm: 'Sei sicuro di voler effettuare il logout?',
      internalContactTitle: 'Referente Int. Stefano Moro',
      language: 'Lingua',
      languageIt: 'Italiano',
      languageEn: 'English',
      languageDe: 'Deutsch',
      languageEs: 'Espanol',
      languageFr: 'Francais',
      pricesVisible: 'Prezzi visibili',
      pricesHidden: 'Prezzi nascosti',
      menuProfile: 'Profilo',
      menuAddressBook: 'Rubrica',
      menuFeedback: 'Commenti e suggerimenti',
    },
    sidebar: {
      home: 'Home',
      customProfiles: 'Profili su misura',
      looseProfiles: 'Profili LED vuoti',
      btmSystem: 'BTM System',
      catalog: 'Catalogo',
      onSale: 'In Offerta',
      newArrivals: 'Novita',
      stripLed: 'Strip LED',
      powerSupplies: 'Alimentatori',
      accessories: 'Accessori',
      cart: 'Carrello',
      orders: 'Ordini',
      menu: 'Menu principale',
      groupConfigure: 'Configura',
      groupProducts: 'Prodotti',
      groupWork: 'Lavoro',
      yourContact: 'Il tuo referente',
      collapse: 'Riduci',
      expand: 'Espandi',
    },
    login: {
      titleLogin: 'Login',
      titleRegister: 'Registrati',
      titleForgot: 'Recupera Password',
      titleReset: 'Reimposta Password',
      landingBadge: 'Accesso B2B riservato',
      landingTitle: 'Accesso riservato ai professionisti dell\'illuminazione',
      landingSubtitle: 'solo per porfessionisti e aziende con piva',
      landingUrgency: 'Attiva il tuo account in meno di 2 minuti.',
      landingBenefit1: 'Prezzi dedicati B2B',
      landingBenefit2: 'Configuratore profili LED su misura',
      landingBenefit3: 'Configuratore profili alluminio vuoti',
      landingBenefit4: 'Configuratore strip LED',
      landingBenefit5: 'Configuratore alimentatori',
      landingBenefit6: 'Configuratore binari elettrificati e relativi accessori e prodotti',
      landingBenefit7: 'Configuratore catalogo generale Goooled',
      landingTrust1: 'Attivazione rapida',
      landingTrust2: 'Supporto dedicato',
      landingTrust3: 'Nessun costo di registrazione',
      registerOnlyTitle: 'Registrazione riservata ai professionisti del settore',
      registerOnlySubtitle: 'Accesso riservato a professionisti e aziende con partita IVA',
      registerHelpPrefix: 'Se hai problemi, contatta',
      preferContactTitle: 'Preferisci essere contattato?',
      preferContactText: 'Se sei un installatore, architetto o professionista del settore e vuoi parlare direttamente con noi, contattaci.',
      contactRequest: 'Richiedi contatto',
      phoneLabel: 'Telefono',
      emailLabel: 'Email',
      companyLogoAlt: 'Logo aziendale',
      nameSurname: 'Nome e cognome',
      company: 'Azienda',
      vatNumber: 'Partita IVA',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Conferma Password',
      newPassword: 'Nuova Password',
      confirmNewPassword: 'Conferma Nuova Password',
      chooseRole: 'Seleziona un ruolo',
      hintLoginEmail: "Serve per l'intestazione dell'account; il login usa la tua email.",
      forgotPrompt: 'Inserisci la tua email per resettare la password.',
      noAccount: 'Non hai un account? Registrati',
      alreadyAccount: 'Hai già un account? Login',
      forgotLink: 'Hai dimenticato la password?',
      backToLogin: 'Torna al Login',
      submitRegister: 'Registrati e accedi al configuratore',
      submitForgot: 'Invia Email di Reset',
      submitReset: 'Reimposta Password',
      submitLogin: 'Login',
      privacy: 'Privacy',
      roleUser: 'User',
      roleElectrician: 'Elettricista',
      roleArchitect: 'Architetto',
      rolePrivate: 'Privato',
      roleCompany: 'Azienda',
      roleAgency: 'Agenzia',
      roleContractor: 'Contractor',
      feedbackVerified: 'Email verificata, ora puoi accedere.',
      errorPasswordsMismatch: 'Le password non corrispondono',
      feedbackRegisterDone:
        'Registrazione completata. Controlla la tua email e conferma prima di accedere. Vuoi uno sconto riservato? Scrivici a info@goooled.com con i tuoi dati aziendali.',
      checkSpamHint: 'Controlla anche la cartella spam/promozioni se non ricevi la mail di conferma.',
      resendVerification: 'Reinvia email di conferma',
      resendingVerification: 'Invio in corso...',
      feedbackVerificationResent: 'Se l\'account esiste, riceverai a breve una nuova email di conferma.',
      errorVerificationResendFailed: 'Impossibile reinviare la email di conferma. Riprova tra poco.',
      errorRegisterFailed: 'Registrazione non riuscita',
      errorUserAlreadyExists: 'Utente già esistente',
      errorCompanyRequired: 'Il nome azienda è obbligatorio',
      errorVatRequired: 'La Partita IVA è obbligatoria',
      errorEmailNotVerified: "Email non verificata. Controlla la casella di posta e clicca sul link di conferma.",
      errorInvalidCredentials: 'Credenziali non valide',
      errorForgotEmailRequired: 'Inserisci la tua email per resettare la password',
      feedbackForgotSent: 'Email per il reset della password inviata. Controlla la tua casella di posta.',
      errorForgotFailed: "Errore nell'invio dell'email di reset della password.",
      errorMinPassword: 'La password deve contenere almeno 8 caratteri',
      feedbackResetDone: 'Password reimpostata con successo! Verrai reindirizzato al login...',
      errorResetFailed: 'Errore durante il reset della password. Per favore, riprova.',
      errorGeneric: 'Si è verificato un errore',
    },
    pcfg: {
      listSubtitle: 'Scegli il profilo: poi finitura, luce, lunghezza e accessori. Codice e prezzo si compongono da soli.',
      default: 'predefinito',
      confirmedOf: '{{n}} di {{total}} scelte confermate',
      allChecked: 'tutto controllato',
      toCheck: 'Da controllare:',
      askOne: 'Prima di aggiungere: una scelta è rimasta sul valore predefinito',
      askMany: 'Prima di aggiungere: {{n}} scelte sono rimaste sul valore predefinito',
      check: 'Controlla',
      addAnyway: 'Aggiungi comunque',
      haveCode: 'Hai già un codice? Incollalo',
      apply: 'Applica',
      copy: 'Copia',
      copied: 'Copiato',
      totalPower: 'Potenza totale',
      strip: 'Strip',
      netPerPiece: 'prezzo netto per pezzo',
      pdfThis: 'Scheda PDF di questa configurazione',
      editingRow: 'Stai modificando una riga del carrello',
      updateRow: 'Aggiorna riga',
      cancelEdit: 'Annulla modifica',
      rowUpdated: 'Riga aggiornata',
      editNotFound: 'Codice della riga non riconosciuto: configurazione predefinita',
      productionNotes: 'Note per la produzione',
      lengthRange: 'Da 30 a {{max}} cm, a passi di 5 cm.',
      maxLength: 'max {{max}} cm',
      monoHint: 'luce da un lato',
      biHint: 'sopra e sotto',
      psu24Hint: 'alimentatore separato',
      psu230Hint: 'alimentatore incluso',
      strip230: 'strip 230Vac: alimentazione 230Vac',
      singleCover: 'unica copertura compatibile',
      dimmerYes: 'Sì, dimmer touch',
      accessoriesHint: 'righe separate nel carrello',
      fixLength: 'Correggi la lunghezza per aggiungere al carrello.',
      accessoriesAvailable: 'Accessori disponibili ({{n}})',
    },
    configurator: {
      groupAll: 'Tutti',
      groupSurface: 'Da superficie',
      groupRecessed: 'Incasso',
      groupSuspended: 'Sospensione',
      customProfiles: 'Profili su misura',
      selectProfile: 'Seleziona il profilo',
      configureProfile: 'Configura il profilo',
      goToCart: 'Vai al carrello',
      backToProfiles: 'Torna ai profili',
      profileType: 'Tipologia profilo',
      profilesAvailable: '{{count}} profili disponibili',
      configure: 'Configura',
      profileImageAndTechnicalAlwaysVisible: 'Immagine profilo e disegno tecnico sempre visibili.',
      profileImage: 'Immagine profilo',
      technicalDrawing: 'Disegno tecnico',
      datasheet: 'Datasheet',
      emission: 'Emissione',
      monoEmission: 'Monoemissione',
      biEmission: 'Biemissione',
      profileColor: 'Colore profilo',
      ledColor: 'Colore LED',
      length: 'Lunghezza',
      lengthHint: 'Inserisci la misura in cm: min 30, max {{max}}, multipli di 5.',
      invalidLength: 'Lunghezza non valida. Deve essere tra 30 e {{max}} cm e multiplo di 5.',
      power: 'Potenza',
      cover: 'Copertura',
      cable: 'Cavo',
      cableExit: 'Uscita cavo',
      dimmerTouch: 'Dimmer touch',
      powerSupply: 'Alimentazione',
      summary: 'Riepilogo',
      notes: 'Note',
      pdfConfiguration: 'PDF Configurazione',
      pdfConfigurationTitle: 'Scarica PDF configurazione',
      suggestedPowerSupply: 'Alimentatore suggerito',
      requiresWatts: 'richiede {{watts}}W (+15%)',
      addPowerSupply: 'Aggiungi alimentatore',
      quantity: 'Quantità',
      addToCart: 'Aggiungi al Carrello',
      viewCart: 'Visualizza Carrello',
      completeConfigurationSummary: 'Completa la configurazione per vedere il riepilogo.',
      code: 'Codice',
      model: 'Modello',
      finish: 'Finitura',
      voltage: 'Voltaggio',
      listPrice: 'Listino',
      netPrice: 'Netto',
      prices: 'Prezzi',
      emissionOption: 'Opzione Emissione',
      dimmerIncluded: 'Incluso',
      powerSupplyType: 'Tipo di Alimentazione',
      warningFillFields: 'Attenzione, tutti i campi devono essere compilati.',
      warningLedPriceUnavailable: 'Errore di configurazione: prezzo LED non disponibile.',
      messageProductAdded: 'Prodotto aggiunto al carrello!',
      warningNoSuggestedPowerSupply: 'Nessun alimentatore suggerito disponibile.',
      warningPowerSupplyCodeUnavailable: 'Codice alimentatore non disponibile.',
      warningPowerSupplyPriceUnavailable: 'Prezzo alimentatore non disponibile.',
      messagePowerSupplyAdded: 'Alimentatore aggiunto al carrello!',
      suggestedPowerSupplyNotes: 'Alimentatore suggerito per il profilo configurato',
      suggestedPowerSupplyFallback: 'profilo attuale',
      cableExitNotesPrefix: 'Uscita cavo',
      warningCompleteBeforePdf: 'Completa la configurazione prima di generare il PDF.',
      warningPdfGeneration: 'Errore nella generazione del PDF.',
      warningPdfCommunication: 'Errore di comunicazione con il server per il PDF.',
      singleCoverAlreadySelected: '{{cover}} già selezionata',
      black: 'Nero',
      white: 'Bianco',
      grey: 'Grigio',
    },
    lp: {
      listSubtitle: 'Profili in alluminio da completare: profilo, copertura, strip e accessori si aggiungono al carrello ognuno per conto suo.',
      profilePart: 'Profilo',
      netEach: 'netto cad.',
      coverHint: 'riga separata nel carrello',
      coverType: 'Tipo copertura',
      totalHint: 'totale netto delle quantità scelte',
    },
    looseProfiles: {
      sectionTitle: 'Profili vuoti',
      selectProfile: 'Seleziona il profilo',
      profileType: 'Tipologia profilo',
      profilesAvailable: '{{count}} profili disponibili',
      configure: 'Configura',
      fromNetPerMeter: 'Da {{value}} netti',
      backToProfiles: 'Torna ai profili',
      mainMenu: 'Menu principale',
      cartWithCount: 'Carrello ({{count}})',
      profilePreview: 'Anteprima profilo',
      profilePreviewIntro: 'Vista prodotto e disegno tecnico sempre accessibili per controllare subito forma e ingombri.',
      productImage: 'Immagine prodotto',
      technicalDrawing: 'Disegno tecnico',
      zoom: 'Ingrandisci',
      profileConfiguration: 'Configurazione profilo',
      profileConfigurationIntro: 'Definisci finitura, lunghezza e quantita del profilo principale.',
      finish: 'Finitura',
      profileLength: 'Lunghezza profilo',
      profileQty: 'Quantita profilo',
      addProfile: 'Aggiungi profilo',
      cover: 'Copertura',
      coverIntro: 'Scegli la copertura compatibile e la sua lunghezza in base al profilo selezionato.',
      coverCompatibility: 'Compatibile con {{covers}}. Lunghezze disponibili: {{lengths}} cm.',
      coverLength: 'Lunghezza copertura',
      coverQty: 'Quantita copertura',
      addCover: 'Aggiungi copertura',
      accessories: 'Accessori',
      accessoriesIntro: 'Completa la configurazione con clips e tappi solo se necessari.',
      clips: 'Clips',
      caps: 'Tappi',
      addClips: 'Aggiungi clips',
      addCaps: 'Aggiungi tappi',
      compatibleStrip: 'Strip LED compatibile',
      compatibleStripIntro: 'Per questo profilo è selezionabile solo la strip LED compatibile indicata.',
      stripQty: 'Quantità bobine',
      addStrip: 'Aggiungi strip LED',
      messageStripAdded: 'Strip LED aggiunta al carrello!',
      addAccessory: 'Aggiungi',
      priceToBeDefined: 'Prezzo da definire',
      messageAccessoryAdded: 'Accessorio aggiunto al carrello!',
      summary: 'Riepilogo',
      goToCart: 'Vai al carrello',
      selectedProfile: 'Profilo selezionato',
      code: 'Codice',
      model: 'Modello',
      type: 'Tipologia',
      length: 'Lunghezza',
      profileQuantity: 'Quantita Profilo',
      listProfile: 'Listino Profilo',
      netProfile: 'Netto Profilo',
      additionalComponents: 'Componenti aggiuntivi',
      coverQuantity: 'Quantita Copertura',
      listCover: 'Listino Copertura',
      netCover: 'Netto Copertura',
      listCaps: 'Listino Tappi',
      netCaps: 'Netto Tappi',
      listClips: 'Listino Clips',
      netClips: 'Netto Clips',
      totalList: 'Totale Listino',
      totalNet: 'Totale Netto',
      prices: 'Prezzi',
      noProfileSummary: 'Seleziona un profilo per vedere il riepilogo.',
      warningSelectModelFinishLength: 'Seleziona modello, finitura e lunghezza.',
      warningValidProfileQty: 'Inserisci una quantita profilo valida.',
      warningProfilePriceUnavailable: 'Prezzo profilo non disponibile.',
      messageProfileAdded: 'Profilo aggiunto al carrello!',
      warningFillAllFields: 'Attenzione, tutti i campi devono essere compilati.',
      warningValidCoverQty: 'Inserisci una quantita copertura valida.',
      warningCoverPriceUnavailable: 'Prezzo copertura non disponibile.',
      messageCoverAdded: 'Copertura aggiunta al carrello!',
      warningModelNotSelected: 'Modello non selezionato.',
      warningClipsUnavailable: 'Clips non disponibili per questo modello.',
      warningValidClipsQty: 'Inserisci una quantita clips valida.',
      messageClipsAdded: 'Clips aggiunte al carrello!',
      warningCapsUnavailable: 'Tappi non disponibili per questo modello.',
      warningValidCapsQty: 'Inserisci una quantita tappi valida.',
      messageCapsAdded: 'Tappi aggiunti al carrello!',
      black: 'Nero',
      white: 'Bianco',
      grey: 'Grigio',
    },
    btm: {
      voltageSelect: 'Seleziona alimentazione',
      select24: 'Seleziona 24VDC',
      select230: 'Seleziona 230VAC',
      loading: 'Caricamento configuratore {{voltage}}...',
      backModels: 'Modelli',
      backModelsAria: 'Torna alla lista modelli',
      backModelsTitle: 'Torna ai modelli',
      changeSupply: 'Cambia',
      changeSupplyAria: 'Torna alla scelta alimentazione',
      changeSupplyTitle: 'Cambia alimentazione',
      chooseTrackModel: 'Scegli il Modello del Binario',
      downloadOnetrackPdf: 'Scarica PDF Onetrack',
      downloadEvoPdf: 'Scarica PDF Evo',
      accessories: 'Accessori',
      installableProducts: 'Prodotti Installabili',
      voltage: 'Tensione',
      datasheet: 'Datasheet',
      white: 'Bianco',
      black: 'Nero',
      listPrice: 'Prezzo Listino',
      netPrice: 'Prezzo Netto',
      prices: 'Prezzi',
      code: 'Codice Prodotto',
      addToCart: 'Aggiungi al Carrello',
      messageAddedToCart: '{{name}} aggiunto al carrello!',
      unavailablePrice: 'Prezzo non disponibile',
      hidden: 'Nascosti',
      itemNames: {
        '906110': 'Testata Alimentazione',
        '9061#11': 'Tappi cechi',
        '906210': 'Giunto Elettrico',
        '9062#13': 'Curva 90°',
        '9064#05': 'Angolare 90°',
        '9064#02': 'Angolare 90°',
        '9064#22': 'Angolare 90°',
        '9062#12': 'Giunto Flessibile',
        '9081#10': 'Testata Alimentazione DX',
        '9081#11': 'Testata Alimentazione SX',
        '9081#15': 'Alimentazione Centrale',
        '9081#13': 'Tappi cechi',
        '9082#23': 'Giunto Elettrico',
        '9082#27': 'Giunto senza contatti',
        '9084#12': 'Staffa lamata per sospensione',
        '9082#20': 'Curva 90°',
        '9082#26': 'Giunto Flessibile',
        '9084#115': 'Attacco soffitto rapido',
        '9084#100': 'Attacco soffitto acciaio',
        '9084#xx': 'Kit sospensione soffitto',
        '9084#210': 'Tronchese per taglio conduttori',
        '9081#14': 'Guaina di tamponamento',
      },
      itemDescriptions: {
        '300702': 'mini Faretto Telemaco D30X76mm 6W 24V',
        '3009001M': 'Telemaco Slim D30x155mm 10W 24V',
        'Telemaco pendente': 'Sospensione minimale D30X115mm',
        GL2041: 'Linea luce SenzaFine sezione 20X20mm',
        GL2043: 'Apparecchio di illuminazione orientabile cilindrico per illuminazione diffusa 360°',
        'Nordic-24': 'Nordic D221 x h220mm 10W 24V',
        '30080113': 'Telemaco 25W 230V',
        'Sospensione Nordic-230': 'Nordic D221 x h220mm 10W 230V',
        'Telemaco pendente-230': 'Sospensione minimale D30X115mm 230V',
      },
    },
    shop: {
      datasheet: 'Scheda',
      net: 'netto',
      code: 'Codice',
      quantity: 'Quantità',
      add: 'Aggiungi',
      indoor: 'interno',
      outdoor: 'esterno',
      stripSubtitle: 'Scegli il colore della luce, poi protezione e potenza: ogni famiglia raccoglie le sue varianti.',
      alimSubtitle: 'Scegli il tipo di alimentazione, poi potenza e controllo.',
      accSubtitle: 'Rosoni e accessori per completare le lampade: scegli la famiglia, poi la finitura.',
      familiesCount: '{{f}} famiglie · {{n}} codici',
      noResults: 'Nessun prodotto con questi filtri.',
      showResults: 'Mostra risultati',
      goToCart: 'Vai al carrello',
      type24v: 'Tensione costante 24V',
      typeCC: 'Corrente costante',
      typeDimmer: 'Dimmer e comandi',
      list: 'Listino',
      specPower: 'Potenza',
      specVolt: 'Volt',
      specCoil: 'Bobina',
      specCut: 'Taglio',
      specSize: 'Misure',
      specOutput: 'Uscita',
    },
    catalog: {
      filters: 'Filtri',
      openFilters: 'Apri filtri',
      closeFilters: 'Chiudi filtri',
      category: 'Categoria',
      subcategory: 'Sottocategoria',
      environment: 'Ambiente',
      resetFilters: 'Reset Filtri',
      residential: 'Residenziale',
      commercial: 'Commerciale',
      industrial: 'Industriale',
      sport: 'Sport',
      wall: 'Parete',
      ceiling: 'Soffitto',
      suspension: 'Sospensione',
      recessedCeiling: 'Incasso Soffitto',
      recessedFloor: 'Incasso a Terra',
      tracklight: 'Tracklight',
      indoor: 'Interno',
      outdoor: 'Esterno',
      net: 'Netto',
      listPrice: 'Listino',
      viewDetails: 'Vedi dettagli',
      noProducts: 'Nessun prodotto trovato.',
      madeInItaly: 'Made in Italy',
      datasheet: 'Datasheet',
      photometry: 'Fotometria',
      code: 'Codice',
      voltage: 'Tensione',
      ledColor: 'Colore LED',
      optics: 'Ottica',
      finish: 'Finitura',
      power: 'Potenza',
      lumen: 'Lumen',
      size: 'Dimensioni',
      addToCart: 'Aggiungi al Carrello',
      addedToCart: 'Prodotto aggiunto al carrello!',
      qtyAria: 'Quantità',
      zoomAlt: 'Vista ingrandita',
      pageTitle: 'Catalogo',
      pageSubtitle: 'Apparecchi a catalogo: scegli installazione e ambiente, poi configura.',
      countOf: '{{n}} di {{total}} prodotti',
      installation: 'Installazione',
      all: 'Tutti',
      track: 'Binario',
      sector: 'Settore',
      resetAll: 'Azzera filtri',
      reset: 'Azzera',
      editFilters: 'Modifica filtri',
      showProducts: 'Mostra {{n}} prodotti',
      netShort: 'netto',
      onlyVersion: 'unica versione',
      editingRow: 'Stai modificando una riga del carrello',
      updateRow: 'Aggiorna riga',
      cancelEdit: 'Annulla modifica',
      editNotFound: 'Prodotto della riga non trovato nel catalogo',
      zoom: 'Ingrandisci',
      photo: 'Foto',
      drawing: 'Disegno',
      goToCart: 'Vai al carrello',
      close: 'Chiudi',
    },
    onSale: {
      title: 'Prodotti in Offerta',
      noProducts: 'Nessun prodotto in offerta disponibile.',
    },
    onNew: {
      title: 'Novita',
      noProducts: 'Nessun prodotto novita disponibile.',
    },
    stripLed: {
      filters: 'Filtri',
      openFilters: 'Apri filtri',
      closeFilters: 'Chiudi filtri',
      ledColor: 'Colore LED',
      power: 'Potenza',
      ipRating: 'Grado IP',
      resetFilters: 'Reset Filtri',
      code: 'Codice',
      voltage: 'Tensione',
      ledsPerMeter: 'LED/m',
      coilLength: 'Lunghezza Bobina',
      cut: 'Taglio',
      cri: 'CRI',
      pcbWidth: 'Larghezza',
      price: 'Prezzo',
      netPrice: 'Prezzo Netto',
      addToCart: 'Aggiungi al Carrello',
      addedToCart: 'Strip LED aggiunta al carrello!',
    },
    accessories: {
      family: 'Famiglia',
      catRosoni: 'Rosoni',
      catSuspensions: 'Kit sospensione',
      catLampholders: 'Portalampade',
      catFixings: 'Staffe e fissaggi',
      finish: 'Finitura',
      cableClamp: 'Serracavo',
      holes: 'Fori',
      material: 'Materiale',
      pack: 'Pezzi',
      addedToCart: 'Accessorio aggiunto al carrello',
    },
    powerSupplies: {
      filters: 'Filtri',
      openFilters: 'Apri filtri',
      closeFilters: 'Chiudi filtri',
      category: 'Categoria',
      power: 'Potenza',
      ipRating: 'Grado IP',
      type: 'Tipologia',
      resetFilters: 'Reset Filtri',
      code: 'Codice',
      size: 'Dimensioni',
      output: 'Out',
      listPrice: 'Prezzo Listino',
      netPrice: 'Prezzo Netto',
      addToCart: 'Aggiungi al Carrello',
      addedToCart: 'Alimentatore aggiunto al carrello!',
      otherAccessories: 'Altri Accessori',
      price: 'Prezzo',
    },
    cart: {
      title: 'Carrello',
      empty: 'Carrello vuoto',
      reference: 'Riferimento',
      referencePlaceholder: 'Es. Cantiere Rossi - Attn. Bianchi',
      orderNotes: 'Note generali',
      recipientQuote: 'Destinatario preventivo',
      pickFromAddressBook: 'Seleziona da rubrica',
      contactName: 'Nome / Contatto',
      companyName: 'Azienda / Ragione sociale',
      email: 'Email',
      phone: 'Telefono',
      address: 'Indirizzo',
      vat: 'P.IVA / CF',
      code: 'Codice',
      description: 'Descrizione',
      listPrice: 'Listino',
      discount: 'Sconto',
      netPrice: 'Prezzo Netto',
      quantity: 'Qtà',
      total: 'Totale',
      rowNotes: 'Note',
      rowNotesPlaceholder: 'Note riga',
      zone: 'Zona',
      zonePlaceholder: 'es. Cucina',
      noZone: 'Nessuna zona',
      newZone: 'Nuova zona',
      clearZone: 'Cancella zona',
      addRow: 'Riga',
      addRowIn: 'Riga in',
      searchRows: 'Cerca codice o descrizione',
      item: 'Articolo',
      expandZone: 'Apri zona',
      collapseZone: 'Chiudi zona',
      renameZone: 'Rinomina',
      zonePrompt: 'Nome della zona (es. Cucina)',
      rowSingular: 'riga',
      rowPlural: 'righe',
      adjustmentTag: 'Abbuono',
      decreaseQty: 'Diminuisci quantità',
      increaseQty: 'Aumenta quantità',
      rowActions: 'Azioni riga',
      moveZoneUp: 'Sposta la zona sopra',
      moveZoneDown: 'Sposta la zona sotto',
      editRowNote: 'Modifica nota riga',
      addRowNote: 'Aggiungi nota riga',
      duplicateRow: 'Duplica riga',
      editRow: 'Modifica',
      moveToZone: 'Sposta in zona',
      noRowsMatch: 'Nessuna riga corrisponde alla ricerca.',
      classicVersion: 'Versione classica del carrello',
      openPhoto: 'Apri foto prodotto',
      zoneNameMissing: 'Scrivi il nome della zona.',
      vatLabel: 'IVA',
      done: 'Fatto',
      saveToAddressBook: 'Salva in rubrica',
      savingToAddressBook: 'Salvataggio in rubrica…',
      savedToAddressBook: 'Salvato in rubrica',
      saveToAddressBookError: 'Non è stato possibile salvare in rubrica. Riprova.',
      edit: 'Modifica',
      ordersCrumb: 'Ordini',
      editingOrder: 'Modifica ordine',
      newQuote: 'Nuovo ordine / preventivo',
      summary: 'Riepilogo',
      rows: 'Righe',
      listTotal: 'Totale a listino',
      discounts: 'Sconti',
      adjustments: 'Abbuoni',
      taxable: 'Imponibile',
      grandTotal: 'Totale',
      commercialTerms: 'Condizioni commerciali',
      close: 'Chiudi',
      moveUp: 'Sposta su',
      moveDown: 'Sposta giù',
      remove: 'Rimuovi',
      up: 'Su',
      down: 'Giù',
      addEmptyRow: 'Aggiungi riga vuota',
      addAdjustment: 'Aggiungi Abbuono',
      clearCart: 'Svuota Carrello',
      backToOrders: 'Torna agli Ordini',
      updateOrder: 'Aggiorna Ordine',
      saveOrder: 'Salva ordine',
      saveOrderTooltip: "L'ordine verrà salvato nella tua lista preventivi/ordini ma non verrà inviato fino a tuo comando.",
      totalLabel: 'Totale',
      validationCheck: 'Controlla i campi del carrello.',
      confirmRemoveRow: 'Rimuovere questa riga?',
      confirmClearCart: 'Svuotare il carrello?',
      alertInvalidAdjustmentAmount: 'Importo non valido.',
      promptAdjustmentAmount: 'Importo abbuono in € (es. 50 o 50,00):',
      promptAdjustmentReason: 'Motivo abbuono (facoltativo):',
      adjustmentDefaultReason: 'Abbuono',
      validationCartEmpty: 'Il carrello è vuoto.',
      validationCodeMissing: 'Codice mancante.',
      validationDescriptionMissing: 'Descrizione mancante.',
      validationPricePositive: 'Il prezzo deve essere maggiore di zero.',
      validationQtyPositive: 'La quantità deve essere maggiore di zero.',
      validationRecipientMissing: 'Inserisci nome contatto e ragione sociale (entrambi) per il destinatario.',
      validationReferenceMissing: 'Inserisci un riferimento ordine.',
      validationAdjustmentNegative: "L'importo abbuono deve essere negativo.",
      validationAdjustmentQty: 'La quantità per abbuono deve essere 1.',
      orderUpdated: 'Ordine aggiornato con successo.',
      orderSaved: 'Ordine salvato con successo.',
      saveError: "Errore durante il salvataggio dell'ordine.",
      recipientUpdateError: "Errore durante l'aggiornamento del destinatario:",
      selectRecipientFromBook: 'Seleziona destinatario dalla rubrica',
      searchRecipientPlaceholder: 'Cerca per nome, azienda, email...',
      noContactFound: 'Nessun contatto trovato...',
      use: 'Usa',
      ok: 'OK',
      adjustmentCode: 'ABBUONO',
      adjustmentDescription: 'Abbuono',
    },
    orders: {
      title: 'Ordini',
      confirmSendTitle: 'Conferma invio ordine',
      confirmSendText: 'Sei sicuro di voler inviare questo ordine?',
      cancel: 'CANCELLA',
      send: 'INVIA',
      sortByDate: 'Ordina per data',
      recentFirst: 'Dal più recente',
      oldestFirst: 'Dal meno recente',
      toSend: 'Da Inviare',
      sent: 'Inviati',
      noneFound: 'Nessun ordine trovato.',
      order: 'Ordine',
      orderNo: 'N° Ordine',
      reference: 'Rif.',
      createdBy: 'Creato da',
      recipient: 'Destinatario',
      date: 'Data',
      status: 'Status',
      total: 'Totale',
      code: 'Codice',
      description: 'Descrizione',
      listPrice: 'Listino',
      netPrice: 'Prezzo Netto',
      quantity: 'Qtà',
      totalPrice: 'Prezzo Totale',
      notes: 'Note',
      exportExcel: 'Esporta ordine in formato Excel',
      exportPdf: 'Esporta ordine in formato PDF',
      received: 'Ordine ricevuto',
      sentAwaiting: 'Ordine inviato in attesa di conferma',
      archive: 'Archivia ordine',
      sendOrder: 'Invia ordine',
      editOrder: 'Modifica ordine',
      duplicateOrder: 'Duplica ordine',
      deleteOrder: 'Elimina ordine',
      confirmDelete: 'Sei sicuro di voler eliminare questo ordine?',
      sendSuccess: 'Ordine inviato con successo!',
      sendError: "Errore durante l'invio dell'ordine.",
      pdfError: 'Errore durante la generazione del PDF.',
      archiveSuccess: 'Ordine archiviato con successo!',
      archiveError: "Errore durante l'archiviazione dell'ordine.",
      unknownUser: 'utente',
      prepared: 'preparato',
      pageTitle: 'Ordini e preventivi',
      pageSubtitle: 'I tuoi ordini e quelli condivisi dalla tua azienda.',
      sendShort: 'Invia',
      sending: 'Invio in corso…',
      cancelShort: 'Annulla',
      customerAccepted: 'Accettato',
      moreActions: 'Altre azioni',
      editSent: 'Modifica (poi da rinviare)',
      statusPrepared: 'Preparato',
      statusRejected: 'Rifiutato',
      statusSent: 'Inviato · in attesa',
      statusAccepted: 'Accettato dal cliente',
      statusReceived: 'Ricevuto da GOOOLED',
      searchingFor: 'Ricerca:',
      colReference: 'Riferimento · cliente',
      colStatus: 'Stato',
      colActions: 'Azioni',
      directOrder: 'Ordine diretto',
      otherItems: 'Altri articoli',
      label: 'Etichetta',
      pagerInfo: 'Ordini {{from}}–{{to}} di {{total}} · {{per}} per pagina',
    },
  },
  en: {
    common: {
      loading: 'Loading...',
      yes: 'Yes',
      no: 'No',
      hidden: 'Hidden',
      notesPlaceholder: 'Notes for production, installation or customer requests',
    },
    home: {
      welcome: 'Welcome to the Configurator',
      heroSubtitle: 'Choose a configurator to get started.',
      quickSearchPlaceholder: 'Search a configurator...',
      openConfigurator: 'Open configurator',
      noResults: 'No configurator found for this search.',
      customProfiles: 'CUSTOM LED PROFILES',
      cardCustomDescription: 'Custom cut and compatible accessories.',
      cardCustomEta: '3-6 min',
      emptyProfiles: 'EMPTY ALUMINUM PROFILES',
      cardLooseDescription: 'Aluminum profiles ready for customization.',
      cardLooseEta: '2-4 min',
      stripLed: 'LED STRIPS',
      cardStripDescription: 'Quick choice by power, IP and LED color.',
      cardStripEta: '2-5 min',
      powerSupplies: 'LED POWER SUPPLIES',
      cardPowerDescription: 'Drivers and power supplies matched to LED systems.',
      cardPowerEta: '1-3 min',
      catalog: 'CATALOG',
      cardCatalogDescription: 'Quickly browse the full product range.',
      cardCatalogEta: '2-4 min',
      btmSystem: 'BTM SYSTEM',
      cardBtmDescription: 'Guided configuration for BTM system.',
      cardBtmEta: '3-7 min',
      newArrivalsTitle: 'New Arrivals',
      newArrivalsSubtitle: 'Discover the latest products.',
      cardNewArrivalsEta: '1-2 min',
      onSaleTitle: 'Products on Sale',
      onSaleSubtitle: 'Discover current offers',
      cardOnSaleEta: '1-2 min',
      categoryConfigurator: 'Configurator',
      categoryProfiles: 'Profiles',
      categoryLighting: 'Lighting',
      categoryElectronics: 'Electronics',
      categoryCatalog: 'Catalog',
      categorySystems: 'Systems',
      categoryNews: 'News',
      categoryPromo: 'Promo',
      greetMorning: 'Good morning',
      greetAfternoon: 'Good afternoon',
      greetEvening: 'Good evening',
      todayQuestion: 'What are we configuring today?',
      newQuote: 'New quote',
      newOrder: 'New order',
      resumeCart: 'Resume your cart',
      openCart: 'Open cart',
      cartEmpty: 'Your cart is empty: start from a configurator below.',
      editingOrder: 'Editing: order',
      draftQuote: 'New quote in progress',
      draftOrder: 'New order in progress',
      linesCount: '{{count}} lines',
      zonesCount: '{{count}} zones',
      lastOrders: 'Latest orders',
      seeAll: 'See all',
      noOrders: 'No orders yet.',
      statusPrepared: 'Prepared',
      statusRejected: 'Rejected',
      statusSent: 'Sent',
      statusReceived: 'Received',
      sectionTitle: 'Configure and order',
      sectionHint: 'Choose where to start',
      open: 'Open',
    },
    account: {
      title: 'Account',
      profile: 'Profile',
      addressBook: 'Address book',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      role: 'Role',
      discount: 'Discount',
      company: 'Company',
      quotes: 'Quotes',
      enabled: 'Enabled',
      disabled: 'No',
      companyKey: 'Company key',
      showPrices: 'Show prices',
      shareOrders: 'Share orders with my company',
      sharingUpdateError: 'Unable to update order sharing preference.',
      country: 'Country',
      saveCountry: 'Save country',
      countryUpdateError: 'Unable to update country.',
      countryIt: 'Italy',
      countryAt: 'Austria',
      countryDe: 'Germany',
      countryEs: 'Spain',
      countryFr: 'France',
      countryOther: 'Other',
      contactReferent: 'For assistance contact the referent:',
    },
    header: {
      admin: 'Admin',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      openSearch: 'Open search',
      closeSearch: 'Close search',
      searchPlaceholder: 'Search products or orders...',
      searchField: 'Search field',
      logout: 'Logout',
      logoutConfirm: 'Are you sure you want to log out?',
      internalContactTitle: 'Internal contact Stefano Moro',
      language: 'Language',
      languageIt: 'Italian',
      languageEn: 'English',
      languageDe: 'German',
      languageEs: 'Spanish',
      languageFr: 'French',
      pricesVisible: 'Prices shown',
      pricesHidden: 'Prices hidden',
      menuProfile: 'Profile',
      menuAddressBook: 'Address book',
      menuFeedback: 'Feedback',
    },
    sidebar: {
      home: 'Home',
      customProfiles: 'Custom profiles',
      looseProfiles: 'Empty LED profiles',
      btmSystem: 'BTM System',
      catalog: 'Catalog',
      onSale: 'On Sale',
      newArrivals: 'New Arrivals',
      stripLed: 'LED Strips',
      powerSupplies: 'Power supplies',
      accessories: 'Accessories',
      cart: 'Cart',
      orders: 'Orders',
      menu: 'Main menu',
      groupConfigure: 'Configure',
      groupProducts: 'Products',
      groupWork: 'Work',
      yourContact: 'Your contact',
      collapse: 'Collapse',
      expand: 'Expand',
    },
    login: {
      titleLogin: 'Login',
      titleRegister: 'Sign up',
      titleForgot: 'Recover Password',
      titleReset: 'Reset Password',
      landingBadge: 'Restricted B2B Access',
      landingTitle: 'Access reserved for lighting professionals',
      landingSubtitle: 'Only installers, architects, contract, interior designers and VAT-registered companies.',
      landingUrgency: 'Activate your account in less than 2 minutes.',
      landingBenefit1: 'Dedicated B2B pricing',
      landingBenefit2: 'Custom LED profile configurator',
      landingBenefit3: 'Empty aluminum profile configurator',
      landingBenefit4: 'LED strip configurator',
      landingBenefit5: 'Power supply configurator',
      landingBenefit6: 'Electrified track configurator with related accessories and products',
      landingBenefit7: 'General Goooled catalog configurator',
      landingTrust1: 'Fast activation',
      landingTrust2: 'Dedicated support',
      landingTrust3: 'No registration fee',
      registerOnlyTitle: 'Registration reserved for industry professionals',
      registerOnlySubtitle: 'Private customers cannot access the platform.',
      registerHelpPrefix: 'If you have issues, contact',
      preferContactTitle: 'Prefer to be contacted?',
      preferContactText: 'If you are an installer, architect or industry professional and want to speak directly with us, contact us.',
      contactRequest: 'Request contact',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      companyLogoAlt: 'Company logo',
      nameSurname: 'Name and surname',
      company: 'Company',
      vatNumber: 'VAT Number',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      chooseRole: 'Select a role',
      hintLoginEmail: 'Used for account header; login uses your email.',
      forgotPrompt: 'Enter your email to reset your password.',
      noAccount: "Don't have an account? Sign up",
      alreadyAccount: 'Already have an account? Login',
      forgotLink: 'Forgot your password?',
      backToLogin: 'Back to Login',
      submitRegister: 'Register and access the configurator',
      submitForgot: 'Send Reset Email',
      submitReset: 'Reset Password',
      submitLogin: 'Login',
      privacy: 'Privacy',
      roleUser: 'User',
      roleElectrician: 'Electrician',
      roleArchitect: 'Architect',
      rolePrivate: 'Private',
      roleCompany: 'Company',
      roleAgency: 'Agency',
      roleContractor: 'Contractor',
      feedbackVerified: 'Email verified, you can now log in.',
      errorPasswordsMismatch: 'Passwords do not match',
      feedbackRegisterDone:
        'Registration completed. Check your email and confirm before logging in. Want a reserved discount? Write to info@goooled.com with your company details.',
      checkSpamHint: 'Also check spam/promotions if you do not receive the confirmation email.',
      resendVerification: 'Resend confirmation email',
      resendingVerification: 'Sending...',
      feedbackVerificationResent: 'If the account exists, you will shortly receive a new confirmation email.',
      errorVerificationResendFailed: 'Unable to resend the confirmation email. Please try again shortly.',
      errorRegisterFailed: 'Registration failed',
      errorUserAlreadyExists: 'User already exists',
      errorCompanyRequired: 'Company name is required',
      errorVatRequired: 'VAT number is required',
      errorEmailNotVerified: 'Email not verified. Check your inbox and click the confirmation link.',
      errorInvalidCredentials: 'Invalid credentials',
      errorForgotEmailRequired: 'Enter your email to reset your password',
      feedbackForgotSent: 'Password reset email sent. Check your inbox.',
      errorForgotFailed: 'Error sending password reset email.',
      errorMinPassword: 'Password must contain at least 8 characters',
      feedbackResetDone: 'Password reset successfully! You will be redirected to login...',
      errorResetFailed: 'Error during password reset. Please try again.',
      errorGeneric: 'An error occurred',
    },
    pcfg: {
      listSubtitle: 'Choose the profile: then finish, light, length and accessories. Code and price are built automatically.',
      default: 'default',
      confirmedOf: '{{n}} of {{total}} choices confirmed',
      allChecked: 'all checked',
      toCheck: 'To check:',
      askOne: 'Before adding: one choice is still on its default value',
      askMany: 'Before adding: {{n}} choices are still on their default value',
      check: 'Check',
      addAnyway: 'Add anyway',
      haveCode: 'Already have a code? Paste it',
      apply: 'Apply',
      copy: 'Copy',
      copied: 'Copied',
      totalPower: 'Total power',
      strip: 'Strip',
      netPerPiece: 'net price per piece',
      pdfThis: 'PDF of this configuration',
      editingRow: 'You are editing a cart row',
      updateRow: 'Update row',
      cancelEdit: 'Cancel edit',
      rowUpdated: 'Row updated',
      editNotFound: 'Row code not recognised: default configuration',
      productionNotes: 'Production notes',
      lengthRange: 'From 30 to {{max}} cm, in 5 cm steps.',
      maxLength: 'max {{max}} cm',
      monoHint: 'light on one side',
      biHint: 'up and down',
      psu24Hint: 'separate power supply',
      psu230Hint: 'power supply included',
      strip230: '230Vac strip: 230Vac supply',
      singleCover: 'only compatible cover',
      dimmerYes: 'Yes, touch dimmer',
      accessoriesHint: 'separate cart lines',
      fixLength: 'Fix the length to add to cart.',
      accessoriesAvailable: 'Available accessories ({{n}})',
    },
    configurator: {
      groupAll: 'All',
      groupSurface: 'Surface',
      groupRecessed: 'Recessed',
      groupSuspended: 'Suspended',
      customProfiles: 'Custom profiles',
      selectProfile: 'Select profile',
      configureProfile: 'Configure profile',
      goToCart: 'Go to cart',
      backToProfiles: 'Back to profiles',
      profileType: 'Profile type',
      profilesAvailable: '{{count}} profiles available',
      configure: 'Configure',
      profileImageAndTechnicalAlwaysVisible: 'Profile image and technical drawing always visible.',
      profileImage: 'Profile image',
      technicalDrawing: 'Technical drawing',
      datasheet: 'Datasheet',
      emission: 'Emission',
      monoEmission: 'Mono emission',
      biEmission: 'Bi emission',
      profileColor: 'Profile color',
      ledColor: 'LED color',
      length: 'Length',
      lengthHint: 'Enter size in cm: min 30, max {{max}}, multiples of 5.',
      invalidLength: 'Invalid length. Must be between 30 and {{max}} cm and a multiple of 5.',
      power: 'Power',
      cover: 'Cover',
      cable: 'Cable',
      cableExit: 'Cable exit',
      dimmerTouch: 'Touch dimmer',
      powerSupply: 'Power supply',
      summary: 'Summary',
      notes: 'Notes',
      pdfConfiguration: 'Configuration PDF',
      pdfConfigurationTitle: 'Download configuration PDF',
      suggestedPowerSupply: 'Suggested power supply',
      requiresWatts: 'requires {{watts}}W (+15%)',
      addPowerSupply: 'Add power supply',
      quantity: 'Quantity',
      addToCart: 'Add to Cart',
      viewCart: 'View Cart',
      completeConfigurationSummary: 'Complete configuration to see the summary.',
      code: 'Code',
      model: 'Model',
      finish: 'Finish',
      voltage: 'Voltage',
      listPrice: 'List price',
      netPrice: 'Net',
      prices: 'Prices',
      emissionOption: 'Emission option',
      dimmerIncluded: 'Included',
      powerSupplyType: 'Power supply type',
      warningFillFields: 'Warning, all fields must be filled.',
      warningLedPriceUnavailable: 'Configuration error: LED price not available.',
      messageProductAdded: 'Product added to cart!',
      warningNoSuggestedPowerSupply: 'No suggested power supply available.',
      warningPowerSupplyCodeUnavailable: 'Power supply code not available.',
      warningPowerSupplyPriceUnavailable: 'Power supply price not available.',
      messagePowerSupplyAdded: 'Power supply added to cart!',
      suggestedPowerSupplyNotes: 'Suggested power supply for configured profile',
      suggestedPowerSupplyFallback: 'current profile',
      cableExitNotesPrefix: 'Cable exit',
      warningCompleteBeforePdf: 'Complete configuration before generating the PDF.',
      warningPdfGeneration: 'Error generating PDF.',
      warningPdfCommunication: 'Communication error with server for PDF.',
      singleCoverAlreadySelected: '{{cover}} already selected',
      black: 'Black',
      white: 'White',
      grey: 'Grey',
    },
    lp: {
      listSubtitle: 'Aluminium profiles to complete: profile, cover, strip and accessories are added to the cart separately.',
      profilePart: 'Profile',
      netEach: 'net each',
      coverHint: 'separate cart line',
      coverType: 'Cover type',
      totalHint: 'net total of the chosen quantities',
    },
    looseProfiles: {
      sectionTitle: 'Empty profiles',
      selectProfile: 'Select profile',
      profileType: 'Profile type',
      profilesAvailable: '{{count}} profiles available',
      configure: 'Configure',
      fromNetPerMeter: 'From {{value}} net',
      backToProfiles: 'Back to profiles',
      mainMenu: 'Main menu',
      cartWithCount: 'Cart ({{count}})',
      profilePreview: 'Profile preview',
      profilePreviewIntro: 'Product view and technical drawing are always available to quickly check shape and dimensions.',
      productImage: 'Product image',
      technicalDrawing: 'Technical drawing',
      zoom: 'Zoom',
      profileConfiguration: 'Profile configuration',
      profileConfigurationIntro: 'Define finish, length and quantity for the main profile.',
      finish: 'Finish',
      profileLength: 'Profile length',
      profileQty: 'Profile quantity',
      addProfile: 'Add profile',
      cover: 'Cover',
      coverIntro: 'Choose compatible cover and length based on selected profile.',
      coverCompatibility: 'Compatible with {{covers}}. Available lengths: {{lengths}} cm.',
      coverLength: 'Cover length',
      coverQty: 'Cover quantity',
      addCover: 'Add cover',
      accessories: 'Accessories',
      accessoriesIntro: 'Complete configuration with clips and caps only if needed.',
      clips: 'Clips',
      caps: 'Caps',
      addClips: 'Add clips',
      addCaps: 'Add caps',
      compatibleStrip: 'Compatible LED strip',
      compatibleStripIntro: 'Only the compatible LED strip shown can be selected for this profile.',
      stripQty: 'Reel quantity',
      addStrip: 'Add LED strip',
      messageStripAdded: 'LED strip added to cart!',
      addAccessory: 'Add',
      priceToBeDefined: 'Price to be defined',
      messageAccessoryAdded: 'Accessory added to cart!',
      summary: 'Summary',
      goToCart: 'Go to cart',
      selectedProfile: 'Selected profile',
      code: 'Code',
      model: 'Model',
      type: 'Type',
      length: 'Length',
      profileQuantity: 'Profile quantity',
      listProfile: 'Profile list price',
      netProfile: 'Profile net',
      additionalComponents: 'Additional components',
      coverQuantity: 'Cover quantity',
      listCover: 'Cover list price',
      netCover: 'Cover net',
      listCaps: 'Caps list price',
      netCaps: 'Caps net',
      listClips: 'Clips list price',
      netClips: 'Clips net',
      totalList: 'Total list',
      totalNet: 'Total net',
      prices: 'Prices',
      noProfileSummary: 'Select a profile to see the summary.',
      warningSelectModelFinishLength: 'Select model, finish and length.',
      warningValidProfileQty: 'Enter a valid profile quantity.',
      warningProfilePriceUnavailable: 'Profile price not available.',
      messageProfileAdded: 'Profile added to cart!',
      warningFillAllFields: 'Warning, all fields must be filled.',
      warningValidCoverQty: 'Enter a valid cover quantity.',
      warningCoverPriceUnavailable: 'Cover price not available.',
      messageCoverAdded: 'Cover added to cart!',
      warningModelNotSelected: 'Model not selected.',
      warningClipsUnavailable: 'Clips not available for this model.',
      warningValidClipsQty: 'Enter a valid clips quantity.',
      messageClipsAdded: 'Clips added to cart!',
      warningCapsUnavailable: 'Caps not available for this model.',
      warningValidCapsQty: 'Enter a valid caps quantity.',
      messageCapsAdded: 'Caps added to cart!',
      black: 'Black',
      white: 'White',
      grey: 'Grey',
    },
    btm: {
      voltageSelect: 'Select power supply',
      select24: 'Select 24VDC',
      select230: 'Select 230VAC',
      loading: 'Loading configurator {{voltage}}...',
      backModels: 'Models',
      backModelsAria: 'Back to model list',
      backModelsTitle: 'Back to models',
      changeSupply: 'Change',
      changeSupplyAria: 'Back to power supply selection',
      changeSupplyTitle: 'Change power supply',
      chooseTrackModel: 'Choose Track Model',
      downloadOnetrackPdf: 'Download Onetrack PDF',
      downloadEvoPdf: 'Download Evo PDF',
      accessories: 'Accessories',
      installableProducts: 'Installable products',
      voltage: 'Voltage',
      datasheet: 'Datasheet',
      white: 'White',
      black: 'Black',
      listPrice: 'List price',
      netPrice: 'Net price',
      prices: 'Prices',
      code: 'Product code',
      addToCart: 'Add to Cart',
      messageAddedToCart: '{{name}} added to cart!',
      unavailablePrice: 'Price unavailable',
      hidden: 'Hidden',
      itemNames: {
        '906110': 'Power feed head',
        '9061#11': 'End caps',
        '906210': 'Electrical joint',
        '9062#13': '90° corner',
        '9064#05': '90° corner bracket',
        '9064#02': '90° corner bracket',
        '9064#22': '90° corner bracket',
        '9062#12': 'Flexible joint',
        '9081#10': 'Right power feed head',
        '9081#11': 'Left power feed head',
        '9081#15': 'Central power feed',
        '9081#13': 'End caps',
        '9082#23': 'Electrical joint',
        '9082#27': 'Mechanical joint',
        '9084#12': 'Suspension plate bracket',
        '9082#20': '90° corner',
        '9082#26': 'Flexible joint',
        '9084#115': 'Quick ceiling mount',
        '9084#100': 'Steel ceiling mount',
        '9084#xx': 'Ceiling suspension kit',
        '9084#210': 'Conductor cutting tool',
        '9081#14': 'Blanking sleeve',
      },
      itemDescriptions: {
        '300702': 'Mini Telemaco spotlight D30x76mm 6W 24V',
        '3009001M': 'Telemaco Slim D30x155mm 10W 24V',
        'Telemaco pendente': 'Minimal pendant D30x115mm',
        GL2041: 'SenzaFine light line section 20x20mm',
        GL2043: 'Adjustable cylindrical fixture for 360° diffused lighting',
        'Nordic-24': 'Nordic D221 x h220mm 10W 24V',
        '30080113': 'Telemaco 25W 230V',
        'Sospensione Nordic-230': 'Nordic D221 x h220mm 10W 230V',
        'Telemaco pendente-230': 'Minimal pendant D30x115mm 230V',
      },
    },
    shop: {
      datasheet: 'Datasheet',
      net: 'net',
      code: 'Code',
      quantity: 'Quantity',
      add: 'Add',
      indoor: 'indoor',
      outdoor: 'outdoor',
      stripSubtitle: 'Choose the light colour, then protection and power: each family groups its variants.',
      alimSubtitle: 'Choose the supply type, then power and control.',
      accSubtitle: 'Ceiling roses and accessories to complete your lamps: choose the family, then the finish.',
      familiesCount: '{{f}} families · {{n}} codes',
      noResults: 'No products match these filters.',
      showResults: 'Show results',
      goToCart: 'Go to cart',
      type24v: 'Constant voltage 24V',
      typeCC: 'Constant current',
      typeDimmer: 'Dimmers and controls',
      list: 'List price',
      specPower: 'Power',
      specVolt: 'Volt',
      specCoil: 'Coil',
      specCut: 'Cut',
      specSize: 'Size',
      specOutput: 'Output',
    },
    catalog: {
      filters: 'Filters',
      openFilters: 'Open filters',
      closeFilters: 'Close filters',
      category: 'Category',
      subcategory: 'Subcategory',
      environment: 'Environment',
      resetFilters: 'Reset Filters',
      residential: 'Residential',
      commercial: 'Commercial',
      industrial: 'Industrial',
      sport: 'Sport',
      wall: 'Wall',
      ceiling: 'Ceiling',
      suspension: 'Suspension',
      recessedCeiling: 'Recessed Ceiling',
      recessedFloor: 'Recessed Floor',
      tracklight: 'Tracklight',
      indoor: 'Indoor',
      outdoor: 'Outdoor',
      net: 'Net',
      listPrice: 'List price',
      viewDetails: 'View details',
      noProducts: 'No products found.',
      madeInItaly: 'Made in Italy',
      datasheet: 'Datasheet',
      photometry: 'Photometry',
      code: 'Code',
      voltage: 'Voltage',
      ledColor: 'LED color',
      optics: 'Optics',
      finish: 'Finish',
      power: 'Power',
      lumen: 'Lumen',
      size: 'Size',
      addToCart: 'Add to Cart',
      addedToCart: 'Product added to cart!',
      qtyAria: 'Quantity',
      zoomAlt: 'Zoomed view',
      pageTitle: 'Catalog',
      pageSubtitle: 'Catalog luminaires: choose mounting and environment, then configure.',
      countOf: '{{n}} of {{total}} products',
      installation: 'Mounting',
      all: 'All',
      track: 'Track',
      sector: 'Sector',
      resetAll: 'Clear filters',
      reset: 'Clear',
      editFilters: 'Edit filters',
      showProducts: 'Show {{n}} products',
      netShort: 'net',
      onlyVersion: 'single version',
      editingRow: 'You are editing a cart row',
      updateRow: 'Update row',
      cancelEdit: 'Cancel edit',
      editNotFound: 'Row product not found in the catalog',
      zoom: 'Zoom',
      photo: 'Photo',
      drawing: 'Drawing',
      goToCart: 'Go to cart',
      close: 'Close',
    },
    onSale: {
      title: 'Products on Sale',
      noProducts: 'No products on sale available.',
    },
    onNew: {
      title: 'New Arrivals',
      noProducts: 'No new products available.',
    },
    stripLed: {
      filters: 'Filters',
      openFilters: 'Open filters',
      closeFilters: 'Close filters',
      ledColor: 'LED color',
      power: 'Power',
      ipRating: 'IP rating',
      resetFilters: 'Reset Filters',
      code: 'Code',
      voltage: 'Voltage',
      ledsPerMeter: 'LED/m',
      coilLength: 'Coil Length',
      cut: 'Cut',
      cri: 'CRI',
      pcbWidth: 'Width',
      price: 'Price',
      netPrice: 'Net price',
      addToCart: 'Add to Cart',
      addedToCart: 'LED strip added to cart!',
    },
    accessories: {
      family: 'Family',
      catRosoni: 'Ceiling roses',
      catSuspensions: 'Suspension kits',
      catLampholders: 'Lampholders',
      catFixings: 'Brackets and fixings',
      finish: 'Finish',
      cableClamp: 'Cable clamp',
      holes: 'Holes',
      material: 'Material',
      pack: 'Pieces',
      addedToCart: 'Accessory added to cart',
    },
    powerSupplies: {
      filters: 'Filters',
      openFilters: 'Open filters',
      closeFilters: 'Close filters',
      category: 'Category',
      power: 'Power',
      ipRating: 'IP rating',
      type: 'Type',
      resetFilters: 'Reset Filters',
      code: 'Code',
      size: 'Size',
      output: 'Out',
      listPrice: 'List price',
      netPrice: 'Net price',
      addToCart: 'Add to Cart',
      addedToCart: 'Power supply added to cart!',
      otherAccessories: 'Other Accessories',
      price: 'Price',
    },
    cart: {
      title: 'Cart',
      empty: 'Cart is empty',
      reference: 'Reference',
      referencePlaceholder: 'Ex. Rossi Site - Attn. Bianchi',
      orderNotes: 'General notes',
      recipientQuote: 'Quote recipient',
      pickFromAddressBook: 'Select from address book',
      contactName: 'Name / Contact',
      companyName: 'Company / Legal name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      vat: 'VAT / Tax ID',
      code: 'Code',
      description: 'Description',
      listPrice: 'List price',
      discount: 'Discount',
      netPrice: 'Net price',
      quantity: 'Qty',
      total: 'Total',
      rowNotes: 'Notes',
      rowNotesPlaceholder: 'Row notes',
      zone: 'Zone',
      zonePlaceholder: 'e.g. Kitchen',
      noZone: 'No zone',
      newZone: 'New zone',
      clearZone: 'Clear zone',
      addRow: 'Row',
      addRowIn: 'Row in',
      searchRows: 'Search code or description',
      item: 'Item',
      expandZone: 'Expand zone',
      collapseZone: 'Collapse zone',
      renameZone: 'Rename',
      zonePrompt: 'Zone name (e.g. Kitchen)',
      rowSingular: 'row',
      rowPlural: 'rows',
      adjustmentTag: 'Adjustment',
      decreaseQty: 'Decrease quantity',
      increaseQty: 'Increase quantity',
      rowActions: 'Row actions',
      moveZoneUp: 'Move zone up',
      moveZoneDown: 'Move zone down',
      editRowNote: 'Edit row note',
      addRowNote: 'Add row note',
      duplicateRow: 'Duplicate row',
      editRow: 'Edit',
      moveToZone: 'Move to zone',
      noRowsMatch: 'No rows match the search.',
      classicVersion: 'Classic cart view',
      openPhoto: 'Open product photo',
      zoneNameMissing: 'Enter the zone name.',
      vatLabel: 'VAT',
      done: 'Done',
      saveToAddressBook: 'Save to address book',
      savingToAddressBook: 'Saving to address book…',
      savedToAddressBook: 'Saved to address book',
      saveToAddressBookError: 'Could not save to the address book. Try again.',
      edit: 'Edit',
      ordersCrumb: 'Orders',
      editingOrder: 'Edit order',
      newQuote: 'New order / quote',
      summary: 'Summary',
      rows: 'Rows',
      listTotal: 'List total',
      discounts: 'Discounts',
      adjustments: 'Adjustments',
      taxable: 'Taxable amount',
      grandTotal: 'Total',
      commercialTerms: 'Commercial terms',
      close: 'Close',
      moveUp: 'Move up',
      moveDown: 'Move down',
      remove: 'Remove',
      up: 'Up',
      down: 'Down',
      addEmptyRow: 'Add empty row',
      addAdjustment: 'Add adjustment',
      clearCart: 'Clear Cart',
      backToOrders: 'Back to Orders',
      updateOrder: 'Update Order',
      saveOrder: 'Save order',
      saveOrderTooltip: 'The order will be saved in your quotes/orders list and will not be sent until your command.',
      totalLabel: 'Total',
      validationCheck: 'Check cart fields.',
      confirmRemoveRow: 'Remove this row?',
      confirmClearCart: 'Clear cart?',
      alertInvalidAdjustmentAmount: 'Invalid amount.',
      promptAdjustmentAmount: 'Adjustment amount in € (ex. 50 or 50.00):',
      promptAdjustmentReason: 'Adjustment reason (optional):',
      adjustmentDefaultReason: 'Adjustment',
      validationCartEmpty: 'Cart is empty.',
      validationCodeMissing: 'Missing code.',
      validationDescriptionMissing: 'Missing description.',
      validationPricePositive: 'Price must be greater than zero.',
      validationQtyPositive: 'Quantity must be greater than zero.',
      validationRecipientMissing: 'Enter contact name and company name (both) for recipient.',
      validationReferenceMissing: 'Enter an order reference.',
      validationAdjustmentNegative: 'Adjustment amount must be negative.',
      validationAdjustmentQty: 'Adjustment quantity must be 1.',
      orderUpdated: 'Order updated successfully.',
      orderSaved: 'Order saved successfully.',
      saveError: 'Error saving order.',
      recipientUpdateError: 'Error updating recipient:',
      selectRecipientFromBook: 'Select recipient from address book',
      searchRecipientPlaceholder: 'Search by name, company, email...',
      noContactFound: 'No contacts found...',
      use: 'Use',
      ok: 'OK',
      adjustmentCode: 'ADJUSTMENT',
      adjustmentDescription: 'Adjustment',
    },
    orders: {
      title: 'Orders',
      confirmSendTitle: 'Confirm order sending',
      confirmSendText: 'Are you sure you want to send this order?',
      cancel: 'CANCEL',
      send: 'SEND',
      sortByDate: 'Sort by date',
      recentFirst: 'Most recent first',
      oldestFirst: 'Oldest first',
      toSend: 'To send',
      sent: 'Sent',
      noneFound: 'No orders found.',
      order: 'Order',
      orderNo: 'Order No.',
      reference: 'Ref.',
      createdBy: 'Created by',
      recipient: 'Recipient',
      date: 'Date',
      status: 'Status',
      total: 'Total',
      code: 'Code',
      description: 'Description',
      listPrice: 'List price',
      netPrice: 'Net price',
      quantity: 'Qty',
      totalPrice: 'Total price',
      notes: 'Notes',
      exportExcel: 'Export order in Excel format',
      exportPdf: 'Export order in PDF format',
      received: 'Order received',
      sentAwaiting: 'Order sent awaiting confirmation',
      archive: 'Archive order',
      sendOrder: 'Send order',
      editOrder: 'Edit order',
      duplicateOrder: 'Duplicate order',
      deleteOrder: 'Delete order',
      confirmDelete: 'Are you sure you want to delete this order?',
      sendSuccess: 'Order sent successfully!',
      sendError: 'Error sending order.',
      pdfError: 'Error generating PDF.',
      archiveSuccess: 'Order archived successfully!',
      archiveError: 'Error archiving order.',
      unknownUser: 'user',
      prepared: 'prepared',
      pageTitle: 'Orders and quotes',
      pageSubtitle: 'Your orders and those shared by your company.',
      sendShort: 'Send',
      sending: 'Sending…',
      cancelShort: 'Cancel',
      customerAccepted: 'Accepted',
      moreActions: 'More actions',
      editSent: 'Edit (then resend)',
      statusPrepared: 'Prepared',
      statusRejected: 'Rejected',
      statusSent: 'Sent · awaiting',
      statusAccepted: 'Accepted by customer',
      statusReceived: 'Received by GOOOLED',
      searchingFor: 'Search:',
      colReference: 'Reference · customer',
      colStatus: 'Status',
      colActions: 'Actions',
      directOrder: 'Direct order',
      otherItems: 'Other items',
      label: 'Label',
      pagerInfo: 'Orders {{from}}–{{to}} of {{total}} · {{per}} per page',
    },
  },
};

const deepCloneTranslations = (value) => JSON.parse(JSON.stringify(value));

// Lingua tedesca.
translations.de = deepCloneTranslations(translations.en);

translations.de.common = {
  ...translations.de.common,
  loading: 'Laden...',
  yes: 'Ja',
  no: 'Nein',
  hidden: 'Ausgeblendet',
  notesPlaceholder: 'Notizen für Produktion, Installation oder Kundenwünsche',
};

translations.de.home = {
  ...translations.de.home,
  welcome: 'Willkommen im Konfigurator',
  heroSubtitle: 'Waehlen Sie einen Konfigurator, um zu starten.',
  quickSearchPlaceholder: 'Konfigurator suchen...',
  openConfigurator: 'Konfigurator oeffnen',
  noResults: 'Kein Konfigurator fuer diese Suche gefunden.',
  customProfiles: 'LED-PROFILE NACH MASS',
  cardCustomDescription: 'Masszuschnitt und kompatibles Zubehoer.',
  cardCustomEta: '3-6 min',
  emptyProfiles: 'LEERE ALUMINIUMPROFILE',
  cardLooseDescription: 'Aluminiumprofile bereit zur Anpassung.',
  cardLooseEta: '2-4 min',
  stripLed: 'LED-STREIFEN',
  cardStripDescription: 'Schnellauswahl nach Leistung, IP und LED-Farbe.',
  cardStripEta: '2-5 min',
  powerSupplies: 'LED-NETZTEILE',
  cardPowerDescription: 'Treiber und Netzteile fuer LED-Systeme.',
  cardPowerEta: '1-3 min',
  catalog: 'KATALOG',
  cardCatalogDescription: 'Schneller Zugriff auf das gesamte Produktsortiment.',
  cardCatalogEta: '2-4 min',
  btmSystem: 'BTM-SYSTEM',
  cardBtmDescription: 'Gefuehrte Konfiguration fuer BTM-System.',
  cardBtmEta: '3-7 min',
  newArrivalsTitle: 'Neuheiten',
  newArrivalsSubtitle: 'Entdecken Sie die neuesten Produkte.',
  cardNewArrivalsEta: '1-2 min',
  onSaleTitle: 'Angebotsprodukte',
  onSaleSubtitle: 'Aktive Angebote entdecken',
  cardOnSaleEta: '1-2 min',
  categoryConfigurator: 'Konfigurator',
  categoryProfiles: 'Profile',
  categoryLighting: 'Beleuchtung',
  categoryElectronics: 'Elektronik',
  categoryCatalog: 'Katalog',
  categorySystems: 'Systeme',
  categoryNews: 'Neuheiten',
  categoryPromo: 'Promo',
};

translations.de.header = {
  ...translations.de.header,
  admin: 'Admin',
  openMenu: 'Menü öffnen',
  closeMenu: 'Menü schließen',
  openSearch: 'Suche öffnen',
  closeSearch: 'Suche schließen',
  searchPlaceholder: 'Produkte oder Bestellungen suchen...',
  searchField: 'Suchfeld',
  logout: 'Abmelden',
  logoutConfirm: 'Möchten Sie sich wirklich abmelden?',
  internalContactTitle: 'Interner Kontakt Stefano Moro',
  language: 'Sprache',
  languageIt: 'Italienisch',
  languageEn: 'Englisch',
  languageDe: 'Deutsch',
  languageEs: 'Spanisch',
  languageFr: 'Franzoesisch',
};

translations.de.account = {
  ...translations.de.account,
  country: 'Land',
  saveCountry: 'Land speichern',
  countryUpdateError: 'Land konnte nicht aktualisiert werden.',
  countryIt: 'Italien',
  countryAt: 'Oesterreich',
  countryDe: 'Deutschland',
  countryEs: 'Spanien',
  countryFr: 'Frankreich',
  countryOther: 'Andere',
};

translations.de.sidebar = {
  ...translations.de.sidebar,
  home: 'Startseite',
  customProfiles: 'Profile nach Maß',
  looseProfiles: 'Leere LED-Profile',
  btmSystem: 'BTM-System',
  catalog: 'Katalog',
  onSale: 'Angebote',
  newArrivals: 'Neuheiten',
  stripLed: 'LED-Streifen',
  powerSupplies: 'Netzteile',
  accessories: 'Zubehör',
  cart: 'Warenkorb',
  orders: 'Bestellungen',
};


translations.de.login = {
  ...translations.de.login,
  titleReset: 'Passwort zuruecksetzen',
  companyLogoAlt: 'Firmenlogo',
  nameSurname: 'Vor- und Nachname',
  company: 'Firma',
  email: 'E-Mail',
  password: 'Passwort',
  confirmPassword: 'Passwort bestaetigen',
  newPassword: 'Neues Passwort',
  confirmNewPassword: 'Neues Passwort bestaetigen',
  chooseRole: 'Rolle auswaehlen',
  hintLoginEmail: 'Wird im Konto angezeigt; fuer den Login wird Ihre E-Mail verwendet.',
  forgotPrompt: 'Geben Sie Ihre E-Mail ein, um das Passwort zurueckzusetzen.',
  noAccount: 'Noch kein Konto? Registrieren',
  alreadyAccount: 'Bereits ein Konto? Anmelden',
  forgotLink: 'Passwort vergessen?',
  backToLogin: 'Zurueck zum Login',
  submitReset: 'Passwort zuruecksetzen',
  roleUser: 'Benutzer',
  roleElectrician: 'Elektriker',
  roleArchitect: 'Architekt',
  rolePrivate: 'Privat',
  roleCompany: 'Firma',
  roleAgency: 'Agentur',
  roleContractor: 'Generalunternehmer',
  feedbackVerified: 'E-Mail bestaetigt, Sie koennen sich jetzt anmelden.',
  errorPasswordsMismatch: 'Passwoerter stimmen nicht ueberein',
  feedbackRegisterDone:
    'Registrierung abgeschlossen. Bitte E-Mail pruefen und vor dem Login bestaetigen. Rabatt gewuenscht? Schreiben Sie an info@goooled.com mit Ihren Firmendaten.',
  errorRegisterFailed: 'Registrierung fehlgeschlagen',
  errorUserAlreadyExists: 'Benutzer existiert bereits',
  errorCompanyRequired: 'Firmenname ist erforderlich',
  errorEmailNotVerified: 'E-Mail nicht bestaetigt. Bitte Postfach pruefen und den Bestaetigungslink anklicken.',
  errorInvalidCredentials: 'Ungueltige Zugangsdaten',
  errorForgotEmailRequired: 'Bitte E-Mail zum Zuruecksetzen eingeben',
  feedbackForgotSent: 'E-Mail zum Zuruecksetzen wurde gesendet. Bitte Postfach pruefen.',
  errorForgotFailed: 'Fehler beim Senden der Reset-E-Mail.',
  errorMinPassword: 'Passwort muss mindestens 8 Zeichen enthalten',
  feedbackResetDone: 'Passwort erfolgreich zurueckgesetzt! Sie werden zum Login weitergeleitet...',
  errorResetFailed: 'Fehler beim Zuruecksetzen des Passworts. Bitte erneut versuchen.',
  errorGeneric: 'Ein Fehler ist aufgetreten',
};

translations.de.configurator = {
  ...translations.de.configurator,
  groupAll: 'Alle',
  groupSurface: 'Aufbau',
  groupRecessed: 'Einbau',
  groupSuspended: 'Pendel',
  customProfiles: 'Profile nach Mass',
  selectProfile: 'Profil auswaehlen',
  configureProfile: 'Profil konfigurieren',
  goToCart: 'Zum Warenkorb',
  backToProfiles: 'Zurueck zu den Profilen',
  profileType: 'Profiltyp',
  profilesAvailable: '{{count}} verfuegbare Profile',
  configure: 'Konfigurieren',
  profileImageAndTechnicalAlwaysVisible: 'Profilbild und technische Zeichnung immer sichtbar.',
  profileImage: 'Profilbild',
  technicalDrawing: 'Technische Zeichnung',
  datasheet: 'Datenblatt',
  emission: 'Emission',
  monoEmission: 'Einseitige Emission',
  biEmission: 'Beidseitige Emission',
  profileColor: 'Profilfarbe',
  ledColor: 'LED-Farbe',
  length: 'Laenge',
  lengthHint: 'Mass in cm eingeben: min 30, max {{max}}, in 5er-Schritten.',
  invalidLength: 'Ungueltige Laenge. Muss zwischen 30 und {{max}} cm liegen und ein Vielfaches von 5 sein.',
  power: 'Leistung',
  cover: 'Abdeckung',
  cable: 'Kabel',
  cableExit: 'Kabelausgang',
  dimmerTouch: 'Touch-Dimmer',
  powerSupply: 'Netzteil',
  summary: 'Zusammenfassung',
  notes: 'Notizen',
  pdfConfiguration: 'Konfigurations-PDF',
  pdfConfigurationTitle: 'Konfigurations-PDF herunterladen',
  suggestedPowerSupply: 'Empfohlenes Netzteil',
  requiresWatts: 'benoetigt {{watts}}W (+15%)',
  addPowerSupply: 'Netzteil hinzufuegen',
  quantity: 'Menge',
  addToCart: 'In den Warenkorb',
  viewCart: 'Warenkorb anzeigen',
  completeConfigurationSummary: 'Konfiguration abschliessen, um die Zusammenfassung zu sehen.',
  code: 'Code',
  model: 'Modell',
  finish: 'Oberflaeche',
  voltage: 'Spannung',
  listPrice: 'Listenpreis',
  netPrice: 'Netto',
  prices: 'Preise',
  emissionOption: 'Emissionsoption',
  dimmerIncluded: 'Enthalten',
  powerSupplyType: 'Netzteiltyp',
  warningFillFields: 'Achtung: Alle Felder muessen ausgefuellt werden.',
  warningLedPriceUnavailable: 'Konfigurationsfehler: LED-Preis nicht verfuegbar.',
  messageProductAdded: 'Produkt zum Warenkorb hinzugefuegt!',
  warningNoSuggestedPowerSupply: 'Kein empfohlenes Netzteil verfuegbar.',
  warningPowerSupplyCodeUnavailable: 'Netzteil-Code nicht verfuegbar.',
  warningPowerSupplyPriceUnavailable: 'Netzteil-Preis nicht verfuegbar.',
  messagePowerSupplyAdded: 'Netzteil zum Warenkorb hinzugefuegt!',
  suggestedPowerSupplyNotes: 'Empfohlenes Netzteil fuer das konfigurierte Profil',
  suggestedPowerSupplyFallback: 'aktuelles Profil',
  cableExitNotesPrefix: 'Kabelausgang',
  warningCompleteBeforePdf: 'Konfiguration vor der PDF-Erstellung abschliessen.',
  warningPdfGeneration: 'Fehler bei der PDF-Erstellung.',
  warningPdfCommunication: 'Kommunikationsfehler mit dem Server fuer PDF.',
  singleCoverAlreadySelected: '{{cover}} bereits ausgewaehlt',
  black: 'Schwarz',
  white: 'Weiss',
  grey: 'Grau',
};

translations.de.looseProfiles = {
  ...translations.de.looseProfiles,
  sectionTitle: 'Leere Profile',
  selectProfile: 'Profil auswaehlen',
  profileType: 'Profiltyp',
  profilesAvailable: '{{count}} verfuegbare Profile',
  configure: 'Konfigurieren',
  fromNetPerMeter: 'Ab {{value}} netto',
  backToProfiles: 'Zurueck zu den Profilen',
  mainMenu: 'Hauptmenue',
  cartWithCount: 'Warenkorb ({{count}})',
  profilePreview: 'Profilvorschau',
  profilePreviewIntro: 'Produktansicht und technische Zeichnung sind immer verfuegbar, um Form und Abmessungen schnell zu pruefen.',
  productImage: 'Produktbild',
  technicalDrawing: 'Technische Zeichnung',
  zoom: 'Zoom',
  profileConfiguration: 'Profilkonfiguration',
  profileConfigurationIntro: 'Definieren Sie Oberflaeche, Laenge und Menge fuer das Hauptprofil.',
  finish: 'Oberflaeche',
  profileLength: 'Profillaenge',
  profileQty: 'Profilmenge',
  addProfile: 'Profil hinzufuegen',
  cover: 'Abdeckung',
  coverIntro: 'Waehlen Sie kompatible Abdeckung und Laenge passend zum ausgewaehlten Profil.',
  coverCompatibility: 'Kompatibel mit {{covers}}. Verfuegbare Laengen: {{lengths}} cm.',
  coverLength: 'Abdeckungslaenge',
  coverQty: 'Abdeckungsmenge',
  addCover: 'Abdeckung hinzufuegen',
  accessories: 'Zubehoer',
  accessoriesIntro: 'Konfiguration bei Bedarf mit Clips und Endkappen ergaenzen.',
  clips: 'Clips',
  caps: 'Endkappen',
  addClips: 'Clips hinzufuegen',
  addCaps: 'Endkappen hinzufuegen',
  summary: 'Zusammenfassung',
  goToCart: 'Zum Warenkorb',
  selectedProfile: 'Ausgewaehltes Profil',
  code: 'Code',
  model: 'Modell',
  type: 'Typ',
  length: 'Laenge',
  profileQuantity: 'Profilmenge',
  listProfile: 'Profil Listenpreis',
  netProfile: 'Profil netto',
  additionalComponents: 'Zusaetzliche Komponenten',
  coverQuantity: 'Abdeckungsmenge',
  listCover: 'Abdeckung Listenpreis',
  netCover: 'Abdeckung netto',
  listCaps: 'Endkappen Listenpreis',
  netCaps: 'Endkappen netto',
  listClips: 'Clips Listenpreis',
  netClips: 'Clips netto',
  totalList: 'Gesamt Listenpreis',
  totalNet: 'Gesamt netto',
  prices: 'Preise',
  noProfileSummary: 'Waehlen Sie ein Profil, um die Zusammenfassung zu sehen.',
  warningSelectModelFinishLength: 'Modell, Oberflaeche und Laenge auswaehlen.',
  warningValidProfileQty: 'Gueltige Profilmenge eingeben.',
  warningProfilePriceUnavailable: 'Profilpreis nicht verfuegbar.',
  messageProfileAdded: 'Profil zum Warenkorb hinzugefuegt!',
  warningFillAllFields: 'Achtung: Alle Felder muessen ausgefuellt werden.',
  warningValidCoverQty: 'Gueltige Abdeckungsmenge eingeben.',
  warningCoverPriceUnavailable: 'Abdeckungspreis nicht verfuegbar.',
  messageCoverAdded: 'Abdeckung zum Warenkorb hinzugefuegt!',
  warningModelNotSelected: 'Modell nicht ausgewaehlt.',
  warningClipsUnavailable: 'Clips fuer dieses Modell nicht verfuegbar.',
  warningValidClipsQty: 'Gueltige Clip-Menge eingeben.',
  messageClipsAdded: 'Clips zum Warenkorb hinzugefuegt!',
  warningCapsUnavailable: 'Endkappen fuer dieses Modell nicht verfuegbar.',
  warningValidCapsQty: 'Gueltige Endkappen-Menge eingeben.',
  messageCapsAdded: 'Endkappen zum Warenkorb hinzugefuegt!',
  black: 'Schwarz',
  white: 'Weiss',
  grey: 'Grau',
};

translations.de.btm = {
  ...translations.de.btm,
  voltageSelect: 'Versorgung auswaehlen',
  select24: '24VDC auswaehlen',
  select230: '230VAC auswaehlen',
  loading: 'Konfigurator {{voltage}} wird geladen...',
  backModels: 'Modelle',
  backModelsAria: 'Zurueck zur Modellliste',
  backModelsTitle: 'Zurueck zu Modellen',
  changeSupply: 'Aendern',
  changeSupplyAria: 'Zurueck zur Auswahl der Versorgung',
  changeSupplyTitle: 'Versorgung aendern',
  chooseTrackModel: 'Schienenmodell auswaehlen',
  downloadOnetrackPdf: 'Onetrack PDF herunterladen',
  downloadEvoPdf: 'Evo PDF herunterladen',
  accessories: 'Zubehoer',
  installableProducts: 'Installierbare Produkte',
  voltage: 'Spannung',
  datasheet: 'Datenblatt',
  white: 'Weiss',
  black: 'Schwarz',
  listPrice: 'Listenpreis',
  netPrice: 'Nettopreis',
  prices: 'Preise',
  code: 'Produktcode',
  addToCart: 'In den Warenkorb',
  messageAddedToCart: '{{name}} zum Warenkorb hinzugefuegt!',
  unavailablePrice: 'Preis nicht verfuegbar',
  hidden: 'Ausgeblendet',
};

translations.de.catalog = {
  ...translations.de.catalog,
  filters: 'Filter',
  openFilters: 'Filter oeffnen',
  closeFilters: 'Filter schliessen',
  category: 'Kategorie',
  subcategory: 'Unterkategorie',
  environment: 'Einsatzbereich',
  resetFilters: 'Filter zuruecksetzen',
  residential: 'Wohnbereich',
  commercial: 'Gewerblich',
  industrial: 'Industrie',
  sport: 'Sport',
  wall: 'Wand',
  ceiling: 'Decke',
  suspension: 'Pendel',
  recessedCeiling: 'Deckeneinbau',
  recessedFloor: 'Bodeneinbau',
  tracklight: 'Schienenleuchte',
  indoor: 'Innen',
  outdoor: 'Aussen',
  net: 'Netto',
  listPrice: 'Listenpreis',
  viewDetails: 'Details anzeigen',
  noProducts: 'Keine Produkte gefunden.',
  madeInItaly: 'Made in Italy',
  datasheet: 'Datenblatt',
  photometry: 'Photometrie',
  code: 'Code',
  voltage: 'Spannung',
  ledColor: 'LED-Farbe',
  optics: 'Optik',
  finish: 'Oberflaeche',
  power: 'Leistung',
  lumen: 'Lumen',
  size: 'Groesse',
  addToCart: 'In den Warenkorb',
  addedToCart: 'Produkt zum Warenkorb hinzugefuegt!',
  qtyAria: 'Menge',
  zoomAlt: 'Vergroesserte Ansicht',
};

translations.de.onSale = {
  ...translations.de.onSale,
  title: 'Angebotsprodukte',
  noProducts: 'Keine Angebotsprodukte verfuegbar.',
};

translations.de.onNew = {
  ...translations.de.onNew,
  title: 'Neuheiten',
  noProducts: 'Keine Neuheiten verfuegbar.',
};

translations.de.stripLed = {
  ...translations.de.stripLed,
  filters: 'Filter',
  openFilters: 'Filter oeffnen',
  closeFilters: 'Filter schliessen',
  ledColor: 'LED-Farbe',
  power: 'Leistung',
  ipRating: 'IP-Schutzart',
  resetFilters: 'Filter zuruecksetzen',
  code: 'Code',
  voltage: 'Spannung',
  ledsPerMeter: 'LED/m',
  coilLength: 'Rollenlaenge',
  cut: 'Schnitt',
  cri: 'CRI',
  price: 'Preis',
  netPrice: 'Nettopreis',
  addToCart: 'In den Warenkorb',
  addedToCart: 'LED-Streifen zum Warenkorb hinzugefuegt!',
};

translations.de.powerSupplies = {
  ...translations.de.powerSupplies,
  filters: 'Filter',
  openFilters: 'Filter oeffnen',
  closeFilters: 'Filter schliessen',
  category: 'Kategorie',
  power: 'Leistung',
  ipRating: 'IP-Schutzart',
  type: 'Typ',
  resetFilters: 'Filter zuruecksetzen',
  code: 'Code',
  size: 'Groesse',
  output: 'Ausgang',
  listPrice: 'Listenpreis',
  netPrice: 'Nettopreis',
  addToCart: 'In den Warenkorb',
  addedToCart: 'Netzteil zum Warenkorb hinzugefuegt!',
  otherAccessories: 'Weiteres Zubehoer',
  price: 'Preis',
};

translations.de.cart = {
  ...translations.de.cart,
  title: 'Warenkorb',
  empty: 'Warenkorb ist leer',
  reference: 'Referenz',
  referencePlaceholder: 'z. B. Baustelle Rossi - z. Hd. Bianchi',
  orderNotes: 'Allgemeine Hinweise',
  recipientQuote: 'Angebotsempfaenger',
  pickFromAddressBook: 'Aus Adressbuch auswaehlen',
  contactName: 'Name / Kontakt',
  companyName: 'Firma / Rechtsname',
  email: 'E-Mail',
  phone: 'Telefon',
  address: 'Adresse',
  vat: 'USt-IdNr. / Steuernr.',
  code: 'Code',
  description: 'Beschreibung',
  listPrice: 'Listenpreis',
  discount: 'Rabatt',
  netPrice: 'Nettopreis',
  quantity: 'Menge',
  total: 'Gesamt',
  rowNotes: 'Notizen',
  rowNotesPlaceholder: 'Zeilen-Notizen',
  moveUp: 'Nach oben',
  moveDown: 'Nach unten',
  remove: 'Entfernen',
  up: 'Hoch',
  down: 'Runter',
  addEmptyRow: 'Leere Zeile hinzufuegen',
  addAdjustment: 'Korrektur hinzufuegen',
  clearCart: 'Warenkorb leeren',
  backToOrders: 'Zurueck zu Bestellungen',
  updateOrder: 'Bestellung aktualisieren',
  saveOrder: 'Bestellung speichern',
  saveOrderTooltip: 'Die Bestellung wird in Ihrer Angebots-/Bestellliste gespeichert und erst auf Ihren Befehl gesendet.',
  totalLabel: 'Gesamt',
  validationCheck: 'Warenkorb-Felder pruefen.',
  confirmRemoveRow: 'Diese Zeile entfernen?',
  confirmClearCart: 'Warenkorb leeren?',
  alertInvalidAdjustmentAmount: 'Ungueltiger Betrag.',
  promptAdjustmentAmount: 'Korrekturbetrag in EUR (z. B. 50 oder 50.00):',
  promptAdjustmentReason: 'Grund der Korrektur (optional):',
  adjustmentDefaultReason: 'Korrektur',
  validationCartEmpty: 'Warenkorb ist leer.',
  validationCodeMissing: 'Code fehlt.',
  validationDescriptionMissing: 'Beschreibung fehlt.',
  validationPricePositive: 'Preis muss groesser als null sein.',
  validationQtyPositive: 'Menge muss groesser als null sein.',
  validationRecipientMissing: 'Bitte Kontaktname und Firmenname (beides) fuer den Empfaenger eingeben.',
  validationReferenceMissing: 'Bitte eine Bestellreferenz eingeben.',
  validationAdjustmentNegative: 'Korrekturbetrag muss negativ sein.',
  validationAdjustmentQty: 'Korrekturmenge muss 1 sein.',
  orderUpdated: 'Bestellung erfolgreich aktualisiert.',
  orderSaved: 'Bestellung erfolgreich gespeichert.',
  saveError: 'Fehler beim Speichern der Bestellung.',
  recipientUpdateError: 'Fehler beim Aktualisieren des Empfaengers:',
  selectRecipientFromBook: 'Empfaenger aus dem Adressbuch auswaehlen',
  searchRecipientPlaceholder: 'Nach Name, Firma, E-Mail suchen...',
  noContactFound: 'Keine Kontakte gefunden...',
  use: 'Verwenden',
  ok: 'OK',
  adjustmentCode: 'KORREKTUR',
  adjustmentDescription: 'Korrektur',
};

translations.de.orders = {
  ...translations.de.orders,
  title: 'Bestellungen',
  confirmSendTitle: 'Bestellversand bestaetigen',
  confirmSendText: 'Moechten Sie diese Bestellung wirklich senden?',
  cancel: 'ABBRECHEN',
  send: 'SENDEN',
  sortByDate: 'Nach Datum sortieren',
  recentFirst: 'Neueste zuerst',
  oldestFirst: 'Aelteste zuerst',
  toSend: 'Zu senden',
  sent: 'Gesendet',
  noneFound: 'Keine Bestellungen gefunden.',
  order: 'Bestellung',
  orderNo: 'Bestellnr.',
  reference: 'Ref.',
  createdBy: 'Erstellt von',
  recipient: 'Empfaenger',
  date: 'Datum',
  status: 'Status',
  total: 'Gesamt',
  code: 'Code',
  description: 'Beschreibung',
  listPrice: 'Listenpreis',
  netPrice: 'Nettopreis',
  quantity: 'Menge',
  totalPrice: 'Gesamtpreis',
  notes: 'Notizen',
  exportExcel: 'Bestellung im Excel-Format exportieren',
  exportPdf: 'Bestellung im PDF-Format exportieren',
  received: 'Bestellung empfangen',
  sentAwaiting: 'Bestellung gesendet, wartet auf Bestaetigung',
  archive: 'Bestellung archivieren',
  sendOrder: 'Bestellung senden',
  editOrder: 'Bestellung bearbeiten',
  duplicateOrder: 'Bestellung duplizieren',
  deleteOrder: 'Bestellung loeschen',
  confirmDelete: 'Moechten Sie diese Bestellung wirklich loeschen?',
  sendSuccess: 'Bestellung erfolgreich gesendet!',
  sendError: 'Fehler beim Senden der Bestellung.',
  pdfError: 'Fehler bei der PDF-Erstellung.',
  archiveSuccess: 'Bestellung erfolgreich archiviert!',
  archiveError: 'Fehler beim Archivieren der Bestellung.',
  unknownUser: 'benutzer',
  prepared: 'vorbereitet',
};

translations.es = deepCloneTranslations(translations.en);
translations.es.common = {
  ...translations.es.common,
  loading: 'Cargando...',
  yes: 'Si',
  no: 'No',
  hidden: 'Oculto',
  notesPlaceholder: 'Notas para produccion, instalacion o solicitudes del cliente',
};
translations.es.home = {
  ...translations.es.home,
  welcome: 'Bienvenido al Configurador',
  heroSubtitle: 'Selecciona un configurador para empezar.',
  quickSearchPlaceholder: 'Buscar un configurador...',
  openConfigurator: 'Abrir configurador',
  noResults: 'No se encontro ningun configurador para esta busqueda.',
  customProfiles: 'PERFILES LED A MEDIDA',
  cardCustomDescription: 'Corte a medida y accesorios compatibles.',
  cardCustomEta: '3-6 min',
  emptyProfiles: 'PERFILES DE ALUMINIO VACIOS',
  cardLooseDescription: 'Perfiles de aluminio listos para personalizar.',
  cardLooseEta: '2-4 min',
  stripLed: 'TIRAS LED',
  cardStripDescription: 'Seleccion rapida por potencia, IP y color LED.',
  cardStripEta: '2-5 min',
  powerSupplies: 'FUENTES LED',
  cardPowerDescription: 'Drivers y fuentes para sistemas LED.',
  cardPowerEta: '1-3 min',
  catalog: 'CATALOGO',
  cardCatalogDescription: 'Explora rapidamente toda la gama de productos.',
  cardCatalogEta: '2-4 min',
  btmSystem: 'BTM SYSTEM',
  cardBtmDescription: 'Configuracion guiada para sistema BTM.',
  cardBtmEta: '3-7 min',
  newArrivalsTitle: 'Novedades',
  newArrivalsSubtitle: 'Descubre los productos mas recientes.',
  cardNewArrivalsEta: '1-2 min',
  onSaleTitle: 'Productos en Oferta',
  onSaleSubtitle: 'Descubre las ofertas activas',
  cardOnSaleEta: '1-2 min',
  categoryConfigurator: 'Configurador',
  categoryProfiles: 'Perfiles',
  categoryLighting: 'Iluminacion',
  categoryElectronics: 'Electronica',
  categoryCatalog: 'Catalogo',
  categorySystems: 'Sistemas',
  categoryNews: 'Novedades',
  categoryPromo: 'Promo',
};
translations.es.header = {
  ...translations.es.header,
  openMenu: 'Abrir menu',
  closeMenu: 'Cerrar menu',
  openSearch: 'Abrir busqueda',
  closeSearch: 'Cerrar busqueda',
  searchPlaceholder: 'Buscar productos o pedidos...',
  searchField: 'Campo de busqueda',
  logoutConfirm: 'Seguro que deseas cerrar sesion?',
  internalContactTitle: 'Contacto interno Stefano Moro',
  language: 'Idioma',
  languageIt: 'Italiano',
  languageEn: 'Ingles',
  languageDe: 'Aleman',
  languageEs: 'Espanol',
  languageFr: 'Frances',
};
translations.es.sidebar = {
  ...translations.es.sidebar,
  customProfiles: 'Perfiles a medida',
  looseProfiles: 'Perfiles LED vacios',
  catalog: 'Catalogo',
  onSale: 'En Oferta',
  newArrivals: 'Novedades',
  stripLed: 'Tiras LED',
  powerSupplies: 'Fuentes',
  accessories: 'Accesorios',
  cart: 'Carrito',
  orders: 'Pedidos',
};
translations.es.login = {
  ...translations.es.login,
  titleRegister: 'Registrarse',
  titleForgot: 'Recuperar contrasena',
  titleReset: 'Restablecer contrasena',
  noAccount: 'No tienes cuenta? Registrate',
  alreadyAccount: 'Ya tienes cuenta? Inicia sesion',
  forgotLink: 'Olvidaste tu contrasena?',
  backToLogin: 'Volver al Login',
  submitRegister: 'Registrarse',
  submitForgot: 'Enviar email de recuperacion',
  submitReset: 'Restablecer contrasena',
  privacy: 'Privacidad',
  errorPasswordsMismatch: 'Las contrasenas no coinciden',
  errorInvalidCredentials: 'Credenciales no validas',
};

translations.fr = deepCloneTranslations(translations.en);
translations.fr.common = {
  ...translations.fr.common,
  loading: 'Chargement...',
  yes: 'Oui',
  no: 'Non',
  hidden: 'Cache',
  notesPlaceholder: 'Notes pour production, installation ou demandes client',
};
translations.fr.home = {
  ...translations.fr.home,
  welcome: 'Bienvenue dans le Configurateur',
  heroSubtitle: 'Choisissez un configurateur pour commencer.',
  quickSearchPlaceholder: 'Rechercher un configurateur...',
  openConfigurator: 'Ouvrir configurateur',
  noResults: 'Aucun configurateur trouve pour cette recherche.',
  customProfiles: 'PROFILS LED SUR MESURE',
  cardCustomDescription: 'Coupe sur mesure et accessoires compatibles.',
  cardCustomEta: '3-6 min',
  emptyProfiles: 'PROFILS ALUMINIUM VIDES',
  cardLooseDescription: 'Profils aluminium prets a personnaliser.',
  cardLooseEta: '2-4 min',
  stripLed: 'BANDES LED',
  cardStripDescription: 'Choix rapide par puissance, IP et couleur LED.',
  cardStripEta: '2-5 min',
  powerSupplies: 'ALIMENTATIONS LED',
  cardPowerDescription: 'Drivers et alimentations adaptes aux systemes LED.',
  cardPowerEta: '1-3 min',
  catalog: 'CATALOGUE',
  cardCatalogDescription: 'Explorez rapidement toute la gamme de produits.',
  cardCatalogEta: '2-4 min',
  btmSystem: 'BTM SYSTEM',
  cardBtmDescription: 'Configuration guidee pour systeme BTM.',
  cardBtmEta: '3-7 min',
  newArrivalsTitle: 'Nouveautes',
  newArrivalsSubtitle: 'Decouvrez les derniers produits.',
  cardNewArrivalsEta: '1-2 min',
  onSaleTitle: 'Produits en Promotion',
  onSaleSubtitle: 'Decouvrez les offres actives',
  cardOnSaleEta: '1-2 min',
  categoryConfigurator: 'Configurateur',
  categoryProfiles: 'Profils',
  categoryLighting: 'Eclairage',
  categoryElectronics: 'Electronique',
  categoryCatalog: 'Catalogue',
  categorySystems: 'Systemes',
  categoryNews: 'Nouveautes',
  categoryPromo: 'Promo',
};
translations.fr.header = {
  ...translations.fr.header,
  openMenu: 'Ouvrir le menu',
  closeMenu: 'Fermer le menu',
  openSearch: 'Ouvrir la recherche',
  closeSearch: 'Fermer la recherche',
  searchPlaceholder: 'Rechercher des produits ou commandes...',
  searchField: 'Champ de recherche',
  logout: 'Deconnexion',
  logoutConfirm: 'Voulez-vous vraiment vous deconnecter ?',
  internalContactTitle: 'Contact interne Stefano Moro',
  language: 'Langue',
  languageIt: 'Italien',
  languageEn: 'Anglais',
  languageDe: 'Allemand',
  languageEs: 'Espagnol',
  languageFr: 'Francais',
};
translations.fr.sidebar = {
  ...translations.fr.sidebar,
  home: 'Accueil',
  customProfiles: 'Profils sur mesure',
  looseProfiles: 'Profils LED vides',
  catalog: 'Catalogue',
  onSale: 'Promotions',
  newArrivals: 'Nouveautes',
  stripLed: 'Bandes LED',
  powerSupplies: 'Alimentations',
  accessories: 'Accessoires',
  cart: 'Panier',
  orders: 'Commandes',
};
translations.fr.login = {
  ...translations.fr.login,
  titleRegister: "S'inscrire",
  titleForgot: 'Recuperer le mot de passe',
  titleReset: 'Reinitialiser le mot de passe',
  noAccount: "Pas de compte ? Inscrivez-vous",
  alreadyAccount: 'Vous avez deja un compte ? Connexion',
  forgotLink: 'Mot de passe oublie ?',
  backToLogin: 'Retour au Login',
  submitRegister: "S'inscrire",
  submitForgot: 'Envoyer email de reinitialisation',
  submitReset: 'Reinitialiser le mot de passe',
  submitLogin: 'Connexion',
  privacy: 'Confidentialite',
  errorPasswordsMismatch: 'Les mots de passe ne correspondent pas',
  errorInvalidCredentials: 'Identifiants invalides',
};

translations.es.account = {
  ...translations.es.account,
  title: 'Cuenta',
  profile: 'Perfil',
  addressBook: 'Libreta de direcciones',
  role: 'Rol',
  discount: 'Descuento',
  company: 'Empresa',
  quotes: 'Presupuestos',
  companyKey: 'Clave empresa',
  showPrices: 'Mostrar precios',
  shareOrders: 'Compartir pedidos con mi empresa',
  sharingUpdateError: 'No se pudo actualizar la preferencia de compartir pedidos.',
  country: 'Pais',
  saveCountry: 'Guardar pais',
  countryUpdateError: 'No se pudo actualizar el pais.',
  countryIt: 'Italia',
  countryAt: 'Austria',
  countryDe: 'Alemania',
  countryEs: 'Espana',
  countryFr: 'Francia',
  countryOther: 'Otro',
};

translations.es.configurator = {
  ...translations.es.configurator,
  groupAll: 'Todos',
  groupSurface: 'Superficie',
  groupRecessed: 'Empotrado',
  groupSuspended: 'Suspendido',
  customProfiles: 'Perfiles a medida',
  selectProfile: 'Seleccionar perfil',
  configureProfile: 'Configurar perfil',
  goToCart: 'Ir al carrito',
  backToProfiles: 'Volver a perfiles',
  profileType: 'Tipo de perfil',
  profilesAvailable: '{{count}} perfiles disponibles',
  configure: 'Configurar',
  profileImage: 'Imagen del perfil',
  technicalDrawing: 'Dibujo tecnico',
  length: 'Longitud',
  power: 'Potencia',
  cover: 'Cobertura',
  cable: 'Cable',
  cableExit: 'Salida de cable',
  dimmerTouch: 'Dimmer tactil',
  powerSupply: 'Alimentacion',
  summary: 'Resumen',
  notes: 'Notas',
  quantity: 'Cantidad',
  addToCart: 'Agregar al carrito',
  viewCart: 'Ver carrito',
  warningFillFields: 'Atencion, todos los campos deben completarse.',
  messageProductAdded: 'Producto agregado al carrito!',
  black: 'Negro',
  white: 'Blanco',
  grey: 'Gris',
};

translations.es.looseProfiles = {
  ...translations.es.looseProfiles,
  sectionTitle: 'Perfiles vacios',
  selectProfile: 'Seleccionar perfil',
  profileType: 'Tipo de perfil',
  profilesAvailable: '{{count}} perfiles disponibles',
  configure: 'Configurar',
  backToProfiles: 'Volver a perfiles',
  mainMenu: 'Menu principal',
  cartWithCount: 'Carrito ({{count}})',
  profilePreview: 'Vista previa del perfil',
  productImage: 'Imagen del producto',
  technicalDrawing: 'Dibujo tecnico',
  profileConfiguration: 'Configuracion del perfil',
  finish: 'Acabado',
  profileLength: 'Longitud del perfil',
  profileQty: 'Cantidad de perfil',
  addProfile: 'Agregar perfil',
  accessories: 'Accesorios',
  clips: 'Clips',
  caps: 'Tapas',
  addClips: 'Agregar clips',
  addCaps: 'Agregar tapas',
  summary: 'Resumen',
  goToCart: 'Ir al carrito',
  black: 'Negro',
  white: 'Blanco',
  grey: 'Gris',
};

translations.es.btm = {
  ...translations.es.btm,
  voltageSelect: 'Seleccionar alimentacion',
  select24: 'Seleccionar 24VDC',
  select230: 'Seleccionar 230VAC',
  loading: 'Cargando configurador {{voltage}}...',
  backModels: 'Modelos',
  changeSupply: 'Cambiar',
  chooseTrackModel: 'Seleccionar modelo de carril',
  accessories: 'Accesorios',
  installableProducts: 'Productos instalables',
  datasheet: 'Ficha tecnica',
  listPrice: 'Precio lista',
  netPrice: 'Precio neto',
  prices: 'Precios',
  addToCart: 'Agregar al carrito',
  unavailablePrice: 'Precio no disponible',
};

translations.es.catalog = {
  ...translations.es.catalog,
  filters: 'Filtros',
  openFilters: 'Abrir filtros',
  closeFilters: 'Cerrar filtros',
  category: 'Categoria',
  subcategory: 'Subcategoria',
  environment: 'Ambiente',
  resetFilters: 'Restablecer filtros',
  residential: 'Residencial',
  commercial: 'Comercial',
  industrial: 'Industrial',
  sport: 'Deporte',
  wall: 'Pared',
  ceiling: 'Techo',
  suspension: 'Suspension',
  recessedCeiling: 'Empotrado techo',
  recessedFloor: 'Empotrado suelo',
  tracklight: 'Carril',
  indoor: 'Interior',
  outdoor: 'Exterior',
  net: 'Neto',
  listPrice: 'Precio lista',
  viewDetails: 'Ver detalles',
  noProducts: 'No se encontraron productos.',
  datasheet: 'Ficha tecnica',
  photometry: 'Fotometria',
  ledColor: 'Color LED',
  optics: 'Optica',
  finish: 'Acabado',
  addToCart: 'Agregar al carrito',
  addedToCart: 'Producto agregado al carrito!',
};

translations.es.onSale = { ...translations.es.onSale, title: 'Productos en Oferta', noProducts: 'No hay productos en oferta.' };
translations.es.onNew = { ...translations.es.onNew, title: 'Novedades', noProducts: 'No hay productos nuevos.' };
translations.es.stripLed = { ...translations.es.stripLed, filters: 'Filtros', resetFilters: 'Restablecer filtros', addToCart: 'Agregar al carrito', addedToCart: 'Tira LED agregada al carrito!' };
translations.es.powerSupplies = { ...translations.es.powerSupplies, filters: 'Filtros', resetFilters: 'Restablecer filtros', addToCart: 'Agregar al carrito', addedToCart: 'Fuente agregada al carrito!' };

translations.es.cart = {
  ...translations.es.cart,
  title: 'Carrito',
  empty: 'El carrito esta vacio',
  reference: 'Referencia',
  orderNotes: 'Notas generales',
  recipientQuote: 'Destinatario presupuesto',
  code: 'Codigo',
  description: 'Descripcion',
  listPrice: 'Precio lista',
  netPrice: 'Precio neto',
  quantity: 'Cant.',
  total: 'Total',
  clearCart: 'Vaciar carrito',
  saveOrder: 'Guardar pedido',
  orderSaved: 'Pedido guardado correctamente.',
};

translations.es.orders = {
  ...translations.es.orders,
  title: 'Pedidos',
  confirmSendTitle: 'Confirmar envio',
  confirmSendText: 'Seguro que deseas enviar este pedido?',
  sortByDate: 'Ordenar por fecha',
  recentFirst: 'Mas recientes primero',
  oldestFirst: 'Mas antiguos primero',
  toSend: 'Por enviar',
  sent: 'Enviado',
  noneFound: 'No se encontraron pedidos.',
  sendSuccess: 'Pedido enviado correctamente!',
  sendError: 'Error al enviar el pedido.',
};

translations.fr.account = {
  ...translations.fr.account,
  title: 'Compte',
  profile: 'Profil',
  addressBook: 'Carnet d adresses',
  role: 'Role',
  discount: 'Remise',
  company: 'Entreprise',
  quotes: 'Devis',
  companyKey: 'Cle entreprise',
  showPrices: 'Afficher les prix',
  shareOrders: 'Partager les commandes avec mon entreprise',
  sharingUpdateError: 'Impossible de mettre a jour la preference de partage des commandes.',
  country: 'Pays',
  saveCountry: 'Enregistrer le pays',
  countryUpdateError: 'Impossible de mettre a jour le pays.',
  countryIt: 'Italie',
  countryAt: 'Autriche',
  countryDe: 'Allemagne',
  countryEs: 'Espagne',
  countryFr: 'France',
  countryOther: 'Autre',
};

translations.fr.configurator = {
  ...translations.fr.configurator,
  groupAll: 'Tous',
  groupSurface: 'Surface',
  groupRecessed: 'Encastre',
  groupSuspended: 'Suspendu',
  customProfiles: 'Profils sur mesure',
  selectProfile: 'Selectionner un profil',
  configureProfile: 'Configurer le profil',
  goToCart: 'Aller au panier',
  backToProfiles: 'Retour aux profils',
  profileType: 'Type de profil',
  profilesAvailable: '{{count}} profils disponibles',
  configure: 'Configurer',
  profileImage: 'Image du profil',
  technicalDrawing: 'Dessin technique',
  length: 'Longueur',
  power: 'Puissance',
  cover: 'Couverture',
  cable: 'Cable',
  cableExit: 'Sortie cable',
  dimmerTouch: 'Variateur tactile',
  powerSupply: 'Alimentation',
  summary: 'Resume',
  notes: 'Notes',
  quantity: 'Quantite',
  addToCart: 'Ajouter au panier',
  viewCart: 'Voir le panier',
  warningFillFields: 'Attention, tous les champs doivent etre remplis.',
  messageProductAdded: 'Produit ajoute au panier!',
  black: 'Noir',
  white: 'Blanc',
  grey: 'Gris',
};

translations.fr.looseProfiles = {
  ...translations.fr.looseProfiles,
  sectionTitle: 'Profils vides',
  selectProfile: 'Selectionner un profil',
  profileType: 'Type de profil',
  profilesAvailable: '{{count}} profils disponibles',
  configure: 'Configurer',
  backToProfiles: 'Retour aux profils',
  mainMenu: 'Menu principal',
  cartWithCount: 'Panier ({{count}})',
  profilePreview: 'Apercu profil',
  productImage: 'Image produit',
  technicalDrawing: 'Dessin technique',
  profileConfiguration: 'Configuration profil',
  finish: 'Finition',
  profileLength: 'Longueur profil',
  profileQty: 'Quantite profil',
  addProfile: 'Ajouter profil',
  accessories: 'Accessoires',
  clips: 'Clips',
  caps: 'Embouts',
  addClips: 'Ajouter clips',
  addCaps: 'Ajouter embouts',
  summary: 'Resume',
  goToCart: 'Aller au panier',
  black: 'Noir',
  white: 'Blanc',
  grey: 'Gris',
};

translations.fr.btm = {
  ...translations.fr.btm,
  voltageSelect: 'Selectionner alimentation',
  select24: 'Selectionner 24VDC',
  select230: 'Selectionner 230VAC',
  loading: 'Chargement configurateur {{voltage}}...',
  backModels: 'Modeles',
  changeSupply: 'Changer',
  chooseTrackModel: 'Choisir modele de rail',
  accessories: 'Accessoires',
  installableProducts: 'Produits installables',
  datasheet: 'Fiche technique',
  listPrice: 'Prix catalogue',
  netPrice: 'Prix net',
  prices: 'Prix',
  addToCart: 'Ajouter au panier',
  unavailablePrice: 'Prix indisponible',
};

translations.fr.catalog = {
  ...translations.fr.catalog,
  filters: 'Filtres',
  openFilters: 'Ouvrir filtres',
  closeFilters: 'Fermer filtres',
  category: 'Categorie',
  subcategory: 'Sous-categorie',
  environment: 'Environnement',
  resetFilters: 'Reinitialiser filtres',
  residential: 'Residentiel',
  commercial: 'Commercial',
  industrial: 'Industriel',
  sport: 'Sport',
  wall: 'Mur',
  ceiling: 'Plafond',
  suspension: 'Suspension',
  recessedCeiling: 'Encastre plafond',
  recessedFloor: 'Encastre sol',
  tracklight: 'Rail',
  indoor: 'Interieur',
  outdoor: 'Exterieur',
  net: 'Net',
  listPrice: 'Prix catalogue',
  viewDetails: 'Voir details',
  noProducts: 'Aucun produit trouve.',
  datasheet: 'Fiche technique',
  photometry: 'Photometrie',
  ledColor: 'Couleur LED',
  optics: 'Optique',
  finish: 'Finition',
  addToCart: 'Ajouter au panier',
  addedToCart: 'Produit ajoute au panier!',
};

translations.fr.onSale = { ...translations.fr.onSale, title: 'Produits en Promotion', noProducts: 'Aucun produit en promotion.' };
translations.fr.onNew = { ...translations.fr.onNew, title: 'Nouveautes', noProducts: 'Aucun nouveau produit disponible.' };
translations.fr.stripLed = { ...translations.fr.stripLed, filters: 'Filtres', resetFilters: 'Reinitialiser filtres', addToCart: 'Ajouter au panier', addedToCart: 'Bande LED ajoutee au panier!' };
translations.fr.powerSupplies = { ...translations.fr.powerSupplies, filters: 'Filtres', resetFilters: 'Reinitialiser filtres', addToCart: 'Ajouter au panier', addedToCart: 'Alimentation ajoutee au panier!' };

translations.fr.cart = {
  ...translations.fr.cart,
  title: 'Panier',
  empty: 'Le panier est vide',
  reference: 'Reference',
  orderNotes: 'Notes générales',
  recipientQuote: 'Destinataire devis',
  code: 'Code',
  description: 'Description',
  listPrice: 'Prix catalogue',
  netPrice: 'Prix net',
  quantity: 'Qt.',
  total: 'Total',
  clearCart: 'Vider panier',
  saveOrder: 'Enregistrer commande',
  orderSaved: 'Commande enregistree avec succes.',
};

translations.fr.orders = {
  ...translations.fr.orders,
  title: 'Commandes',
  confirmSendTitle: 'Confirmer envoi',
  confirmSendText: 'Voulez-vous envoyer cette commande ?',
  sortByDate: 'Trier par date',
  recentFirst: 'Plus recentes en premier',
  oldestFirst: 'Plus anciennes en premier',
  toSend: 'A envoyer',
  sent: 'Envoye',
  noneFound: 'Aucune commande trouvee.',
  sendSuccess: 'Commande envoyee avec succes!',
  sendError: 'Erreur pendant envoi de la commande.',
};


